// RITM1195257 added by Hasan
import React, { Component } from 'react';
import {
    TextInput,
    Button,
    Table,
    DatePickerInput,
    DatePicker,
    StructuredListCell,
    StructuredListBody,
    Toggle,
    ToggleSmall,
    ModalWrapper,
    StructuredListHead,
    StructuredListRow,
    Form,
    Accordion,
    AccordionItem,
    DataTable,
    StructuredListWrapper,
    TableContainer,
    TableHead,
    TableHeader,
    TableBody,
    TableRow,
    TableCell,
    Checkbox,
    FormLabel,
    FileUploader,
    RadioButtonGroup,
    FormGroup,
    MultiSelect,
    RadioButton,
    TextArea,
    TimePicker,
    TimePickerSelect,
    Tabs,
    Tab,
    ComposedModal,
    ModalHeader,
    ModalBody,
    SelectItem,
    TooltipIcon,
    DropdownSkeleton, //RITM1143712
} from 'carbon-components-react';
import CheckmarkFilled16 from '@carbon/icons-react/lib/checkmark--filled/16';
import CheckmarkOutline16 from '@carbon/icons-react/lib/checkmark--outline/16';
import View16 from '@carbon/icons-react/lib/view--filled/16';
import Add16 from '@carbon/icons-react/lib/add/16';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import OverFlowVertical16 from '@carbon/icons-react/lib/overflow-menu--vertical/16';
import Radiobutton16 from '@carbon/icons-react/lib/radio-button/16';
import { ChevronLeft16, Information16 } from '@carbon/icons-react';
import { ScrollingProvider, Section } from '../../lib/react-scroll-section/src/index';
import { Menu, Item } from '../../helpers/scrolling/ScrollingMenuItem';
import '../../scss/custom.scss';
import { ENGINE_METHOD_NONE } from 'constants';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import { ComboBox } from '../../helpers/ComboBox';
import MultiComboBox from '../../helpers/MultiComboBox';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
    getSuccess,
    getError,
    entitiesLabels,
    apioperation,
    DateFormat,
} from '../../helpers/Constants';
import SimpleReactValidator from 'simple-react-validator';
import { api,dynamic } from '../../helpers/api/api';
import moment from 'moment';
import { IsInRole, IsEditable } from '../../helpers/authorization/Policies';
import EmailChips from '../../helpers/EmailChips';
import DateTimePicker from '../../helpers/DateTimePicker';
import { v4 as uuid } from 'uuid';
import { IncidentAttachment } from './IncidentAttachment';
//RITM0615454_DEV615_MatriciOutcomes
import AssestmentLevelTable from './AssestmentLevelTable';
import IncidentHighConsequence from './IncidentHighConsequence'; //RITM1147493
//RITM1147493
// const incidentTabNotificationsModel = {
//     occurrenceDate: '',
//     occurrenceTime: '',

//     idWorkSiteProject: null,
//     idWorksite: null,
//     idProject: null,
//     idActivity: null,

//     idDivision: null,
//     idCompany: null,
//     idCountry: null,
//     idCustomer: null,

//     division: '', //solo visualizzazione
//     company: '', //solo visualizzazione
//     country: '', //solo visualizzazione
//     customer: '', //solo visualizzazione

//     type: '', //*Il Type si ricava sulla base dei valori selezionati di Real Outcome. Basta un valore Real Outcome a Yes selezionato per determinare il valore Accident per il Type

//     outcomeAsset: null,
//     outcomeEnvironmental: null,
//     outcomeHarm: null,
//     realOutcomeAsset: null,
//     realOutcomeEnvironmental: null,
//     realOutcomeHarm: null,

// //RITM0615454_DEV615_MatriciOutcomes
//     incidentOutcomes: [],
//     //----

//     emergencyClass: '',
//     publicAuthoritiesAndEntitiesInvolved: '',
//     specifyOther: '',
//     transportAccident: '',
//     transportAccidentEquipped: null,
//     infoOriginator: '',

//     //region details
//     title: '',
//     workRelated: '',
//     place: '',
//     companyVehicleProvided: null,
//     briefDescription: '',
//     immediateActionsTaken: '',

//     //region Assessment
//     //RITM0615454_DEV615_MatriciOutcomes
//     idInvestigationLevelRealConsequenceSeverity: uuid(),
//     idInvestigationLevelPotentialConsequenceSeverity: uuid(), //matrix
//     idInvestigationLevelPotentialConsequenceProbability: uuid(), //matrix
//     idRealConsequenceSeverity: null,
//     idPotentialConsequenceSeverity: null,

//     //region LifeSavingRules
//     lifeSavingRules: null,
//     lsrNote: '',
//     //notificationDate: undefined,
//     mailTo: '',
//     mailCc: '',
//     mailBody: '',
//     mailSubject: '',

//     attachmentNotifications: [],
//     // idHighConsequenceLevelActual: null, //RITM1147493
//     // idHighConsequenceLevelPotentialWorstCase: null, //RITM1147493
//     // idHighConsequenceLevelPotentialFinal: null, //RITM1147493
// };

const baseUrl = '/incident/';
const filterByDate = (el, date) => {
    let startDate = moment(el.start).format('YYYY-MM-DD'); //A2_Start_Date_End_Date_Issue
    let endDate = moment(el.end).format('YYYY-MM-DD'); //A2_Start_Date_End_Date_Issue
    return startDate <= moment(date).format('YYYY-MM-DD') && moment(date).format('YYYY-MM-DD') <= endDate; //A2_Start_Date_End_Date_Issue
};
//RITM0615454_DEV615_MatriciOutcomes
const INCIDENT_OUTCOME_ENUM = {
    outcomeHarm: { idOutcome: 0, title: "Harm To People" },
    outcomeAsset: { idOutcome: 1, title: "Property/Asset" },
    outcomeEnvironmental: { idOutcome: 2, title: "Environmental" },
}

export default class IncidentTabNotification extends Component {
    initialState = (props) => {
        let initialState = {
            listWorksitesPrj: [],
            flagTime: false,
            appWorksites: null,
            appProject: null,
            showConsequenceLegend: false,
            outcomeTab: 0, //RITM0615454_DEV615_MatriciOutcomes
            //RITM1147493
            // incidentModel: {
            //     ...incidentTabNotificationsModel,
            // },
            incidentModel: {
                occurrenceDate: '',
                occurrenceTime: '',

                idWorkSiteProject: null,
                idWorksite: null,
                idProject: null,
                idActivity: null,

                idDivision: null,
                idCompany: null,
                idCountry: null,
                idCustomer: null,

                division: '', //solo visualizzazione
                company: '', //solo visualizzazione
                country: '', //solo visualizzazione
                customer: '', //solo visualizzazione

                type: '', //*Il Type si ricava sulla base dei valori selezionati di Real Outcome. Basta un valore Real Outcome a Yes selezionato per determinare il valore Accident per il Type

                outcomeAsset: null,
                outcomeEnvironmental: null,
                outcomeHarm: null,
                realOutcomeAsset: null,
                realOutcomeEnvironmental: null,
                realOutcomeHarm: null,

            //RITM0615454_DEV615_MatriciOutcomes
                incidentOutcomes: [],
                //----

                emergencyClass: '',
                // RITM1195257 added countryLCU
                countryLCU: '', 
                publicAuthoritiesAndEntitiesInvolved: '',
                specifyOther: '',
                transportAccident: '',
                transportAccidentEquipped: null,
                infoOriginator: '',

                //region details
                title: '',
                workRelated: '',
                place: '',
                companyVehicleProvided: null,
                briefDescription: '',
                immediateActionsTaken: '',

                //region Assessment
                //RITM0615454_DEV615_MatriciOutcomes
                idInvestigationLevelRealConsequenceSeverity: null, //RITM1405215
                idInvestigationLevelPotentialConsequenceSeverity: null, //matrix RITM1405215
                idInvestigationLevelPotentialConsequenceProbability: null, //matrix RITM1405215

                //region LifeSavingRules
                lifeSavingRules: null,
                lsrNote: '',
                //notificationDate: undefined,
                mailTo: '',
                mailCc: '',
                mailBody: '',
                mailSubject: '',

                attachmentNotifications: [],
                maskedValue: false, //RITM0946001 - Anonimizzazione Modulo Incident
            },
            isDisabled: props.incidentEditModel
                ? !IsEditable(
                    'Incident',
                    'Reporting',
                    props.user,
                    props.incidentEditModel.status.id,
                    'Notification',
                    props.incidentEditModel
                )
                : false,
        };

        if (props.incidentEditModel) {
            initialState.incidentModel = { ...props.incidentEditModel };
            initialState.outcomeTab = this.getFirstActiveOutcomeTab(initialState.incidentModel)
            if (initialState.incidentModel.occurrenceDate) {
                let dateTime = this.convertOccurrenceDate(1, initialState.incidentModel.occurrenceDate);
                initialState.incidentModel.occurrenceDate = dateTime.occurrenceDate;
                initialState.incidentModel.occurrenceTime = dateTime.occurrenceTime;
            }
        }

        return initialState;
    };

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator({ locale: 'en' });
        this.validatorTime = new SimpleReactValidator({ locale: 'en' });
        this.updateState = this.updateState.bind(this);
        this.handleChangeCombo = this.handleChangeCombo.bind(this);
        this.state = {
            ...this.initialState(props),
            //RITM1216061 
            AELValue : null,
            PELWCValue : null,
            PELFinalValue : null,
            AHLValue : null,
            PHLWCValue : null,
            PHLFinalValue: null,
            //RITM1216061 end
        };
        // RITM0615447
        this.idNoViolationLifeSavingRule = "4e732b42-fb52-4a46-b49c-6decdcd94d80"       
    }
    componentDidMount(){
        this.getIncidentHighConsequenceLevel(); 
    }


    componentWillReceiveProps(nextProps) {
        //loading valori combo calcolate,
        if (
            nextProps.incidentEditModel &&
            this.state.incidentModel.occurrenceDate &&
            nextProps.appAllWorksites &&
            nextProps.appAllWorksitePrj
        ) {
            let occurrenceDate = this.state.incidentModel.occurrenceDate;
            let appWorksites = null;
            let appProject = null;
            let listWorksitesPrj = [];

            if (/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(occurrenceDate))
                appWorksites = (nextProps.appAllWorksites || []).filter((el) =>
                    filterByDate(el, occurrenceDate)
                );

            if (this.state.incidentModel.idWorksite) {
                let idWorksite = this.state.incidentModel.idWorksite;

                listWorksitesPrj = (nextProps.appAllWorksitePrj || []).filter(
                    (el) => el.idWorkSite == idWorksite
                );

                if (/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(occurrenceDate))
                    listWorksitesPrj = (listWorksitesPrj || []).filter((el) =>
                        filterByDate(el, occurrenceDate)
                    );

                appProject = listWorksitesPrj.map((item) => ({
                    id: item.idProject,
                    name: item.project,
                    idWorksitePrj: item.id,
                }));
            }

            this.setState({
                appWorksites,
                listWorksitesPrj,
                appProject,
            });
        }
    }

    selectTab = (index) => {
        this.props.selectTab(index);
    };
    addNewAttachment = (data) => {
        try {
            if (data == null) return;
            //insert
            let oldattachment = this.state.incidentModel.attachmentNotifications || [];

            let newItem = {
                id: uuid(), //guid
                idIncident: this.props.incidentEditModel?.id ? this.props.incidentEditModel.id : uuid(),
                idAttachment: data.id, //guid
                attachment: data,
            };

            let newattachment = oldattachment.concat([newItem]);
            this.updateState('attachmentNotifications', newattachment, 'incidentModel');
        } catch (error) {
            showNotification.error();
        }
    };
    removeAttachment = (id) => {
        if (!id) return;

        let statusCopy = Object.assign({}, this.state.incidentModel);
        statusCopy.attachmentNotifications = statusCopy.attachmentNotifications.filter(
            (el) => el.id !== id
        );

        this.setState({
            incidentModel: statusCopy,
        });
    };
    getWorkSite(occurrenceDate) {
        try {
            var data = this.props.appAllWorksites;

            if (/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(occurrenceDate))
                data = (data || []).filter((el) => filterByDate(el, occurrenceDate));

            this.setState({
                appWorksites: data,
            });
        } catch {
            showNotification.error(
                `${entitiesLabels.ERROR}`,
                'Error filtering ' + entitiesLabels.WORKSITE
            );
            this.setState({
                listWorksitesPrj: [],
                appWorksites: null,
                appProject: null,
            });
        }
    }

    getWorksitesPrj(idWorksite, occurrenceDate) {
        try {
            var data = (this.props.appAllWorksitePrj || []).filter((el) => el.idWorkSite == idWorksite);

            if (/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(occurrenceDate))
                data = (data || []).filter((el) => filterByDate(el, occurrenceDate));

            var appProject = data.map((item) => ({
                id: item.idProject,
                name: item.project,
                idWorksitePrj: item.id,
            }));

            this.setState({
                listWorksitesPrj: data,
                appProject,
            });
        } catch {
            showNotification.error(
                `${entitiesLabels.ERROR}`,
                'Error filtering ' + entitiesLabels.WORKSITEPROJECT
            );
            this.setState({
                listWorksitesPrj: [],
                appProject: null,
            });
        }
        // api.getAll(baseUrl + 'worksiteproject/' + idWorksite)
        //     .then(response => {
        //         var data = response.data;
        //         if (/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(occurrenceDate))
        //             data = data != null ? data.filter(el => filterByDate(el, occurrenceDate)) : [];
        //         var appProject = data.map(item => ({ id: item.idProject, name: item.project, idWorksitePrj: item.id }));

        //         this.setState({
        //             listWorksitesPrj: data,
        //             appProject
        //         });
        //     }).catch(error => {
        //         showNotification.error(getError(error, entitiesLabels.WORKSITEPROJECT, apioperation.GET));
        //         this.setState({
        //             listWorksitesPrj: [],
        //             appProject: null
        //         });
        //     }).finally(() => {

        //     });
    }
    getTooltip(item) {
        if (item.code == 1) {
            return 'Never occurred in the Oil&Gas sector.';
        }
        if (item.code == 2) {
            return 'Already occurred in the Oil&Gas sector. Similar occurrences have already been recorded in the Oil&Gas sector. ';
        }
        if (item.code == 3) {
            return 'Already occurred in the Company. Some similar occurrences have already been recorded in the Saipem group (less than once a year). ';
        }
        if (item.code == 4) {
            return 'It has occurred many times in the Company. Many occurrences have already been recorded in the Saipem group (more than once a year). ';
        }
        if (item.code == 5) {
            return 'It has occurred on the site many times a year. Many occurrences have already been recorded at one particular branch in the Saipem group (more than once a year). ';
        }
    }
    updateState = (inputName, inputValue, objName) => {
        let statusCopy = Object.assign({}, this.state);
        statusCopy[objName][inputName] = inputValue;

    //DEV 615
        const oucomePropertyNames = ["outcomeHarm", "outcomeAsset", "outcomeEnvironmental"]
        const realOutcomePropertyNames = ["realOutcomeHarm", "realOutcomeAsset", "realOutcomeEnvironmental"]
        let idOutcome = null;
        if (oucomePropertyNames.includes(inputName)) {
            idOutcome = INCIDENT_OUTCOME_ENUM[inputName].idOutcome


            if (inputValue === false) statusCopy.incidentModel.incidentOutcomes = statusCopy.incidentModel.incidentOutcomes?.filter(el => el.idOutcome !== idOutcome)
            else {
                const alreadyExist = statusCopy.incidentModel.incidentOutcomes.find(out => out.idOutcome === idOutcome)
                if (!alreadyExist) {
                    const outcomeObj = { idOutcome, idIncident: this.state.incidentModel?.id }
                    statusCopy.incidentModel.incidentOutcomes.push(outcomeObj)
                }
            }
            //RITM1216061
            if (inputName == 'outcomeHarm' && inputValue === false)
            {
                statusCopy.AHLValue = null
                statusCopy.PHLWCValue = null
                statusCopy.PHLFinalValue = null
            }
            if (inputName == 'outcomeEnvironmental' && inputValue === false)
            {
                statusCopy.AELValue = null
                statusCopy.PELWCValue = null
                statusCopy.PELFinalValue = null
            }
            //End
            const isTheOnlyOneActive = oucomePropertyNames.filter(property => statusCopy.incidentModel[property] === true)?.length === 1 ? true : false
            if ((inputValue === false && idOutcome === this.state.outcomeTab) || (inputValue === true && isTheOnlyOneActive)) statusCopy.outcomeTab = this.getFirstActiveOutcomeTab(statusCopy.incidentModel)
        }

        if (realOutcomePropertyNames.includes(inputName)) {
            const propertyName = oucomePropertyNames.find(property => inputName.toLowerCase().includes(property.toLowerCase()))
            idOutcome = INCIDENT_OUTCOME_ENUM[propertyName].idOutcome

            const alreadyExistingOut = statusCopy.incidentModel.incidentOutcomes.find(out => out.idOutcome === idOutcome)

            if (!alreadyExistingOut) {
                const outcomeObj = { idOutcome, idIncident: this.state.incidentModel?.id }
                statusCopy.incidentModel.incidentOutcomes.push(outcomeObj)
            }

            //RITM1216061
            if (inputName == 'realOutcomeHarm' || inputName == 'realOutcomeEnvironmental') {
                const alreadyExistingOutcome = statusCopy.incidentModel.incidentOutcomes.find(out => out.idOutcome === idOutcome)
                if (inputValue == false){
                    const objHighConsequenceLevelActual = this.props.appHighConsequenceLevels.filter(out => out.outcome === idOutcome && (idOutcome == 0 ? out.code === 'H0' : out.code === 'E0'))
                    if (alreadyExistingOutcome)
                        alreadyExistingOutcome.idHighConsequenceLevelActual = objHighConsequenceLevelActual[0]?.id
                }
                else if (inputValue == true){
                    if (alreadyExistingOutcome)
                        alreadyExistingOutcome.idHighConsequenceLevelActual = null
                }
            }
            //End
           
        }
        //FINE DEV 615
    

        this.setState(statusCopy);
    };

    //RITM0615454_DEV615_MatriciOutcomes
    getFirstActiveOutcomeTab = (model) => {
        const oucomePropertyNames = ["outcomeHarm", "outcomeAsset", "outcomeEnvironmental"]
        let activeOutcomeIds = []
        oucomePropertyNames.forEach(outName => {
            if (model && model[outName] === true) {
                const idOutcome = INCIDENT_OUTCOME_ENUM[outName].idOutcome
                activeOutcomeIds.push(idOutcome)
            }
        })
        if (activeOutcomeIds.length === 0) return 0
        if (activeOutcomeIds.length === 1) return activeOutcomeIds[0]
        return activeOutcomeIds.sort((a, b) => a - b)[0]
    }
    //FINE //RITM0615454_DEV615_MatriciOutcomes
    updateStatesTime = (inputName, inputValue, objName) => {
        if (inputValue == false) {
            this.setState({ flagTime: true });
            if (!this.validatorTime.allValid()) {
                this.validatorTime.showMessages();
            }
        } else {
            let statusCopy = Object.assign({}, this.state);
            statusCopy[objName][inputName] = inputValue;
            statusCopy.flagTime = false;
            this.setState(statusCopy);
        }
    };

    handleChangeModel = (el) => {
        let inputName = el.target.name;
        let inputValue = el.target.value;
        let objName = el.target.alt;
        this.updateState(inputName, inputValue, objName);
    };

    handleChangeTitle = (el) => {
        let inputName = el.target.name;
        let inputValue = el.target.value;
        let objName = el.target.alt;

        let statusCopy = Object.assign({}, this.state);
        statusCopy[objName][inputName] = inputValue;
        this.setState(statusCopy);
    };

    //nelle combobox da richiamare, in modo sincrono, dopo il primo setState
    loadRelatedProperties = (inputName, inputValue, selectedItem) => {
        if (inputName == 'occurrenceDate') {
            if (inputValue) this.getWorkSite(inputValue);
            else
                this.setState({
                    appWorksites: null,
                    listWorksitesPrj: [],
                    appProject: null,
                });
        }

        if (inputName == 'idWorksite') {
            if (inputValue) this.getWorksitesPrj(inputValue, this.state.incidentModel.occurrenceDate);
            else {
                this.setState({
                    listWorksitesPrj: [],
                    appProject: null,
                });
            }
        }
    };

    handleChangeMultiCombo = (inputName, selectedItem, objName) => {
        let inputValue =
            selectedItem && selectedItem.length ? selectedItem.map((el) => el.name).join(',') : null;

        let statusCopy = Object.assign({}, this.state[objName]);
        statusCopy[inputName] = inputValue;

        this.setState({ [objName]: statusCopy });
    };

    handleChangeCombo = (inputName, selectedItem, objName) => {
        let inputValue = selectedItem ? selectedItem.id : null;

        let statusCopy = Object.assign({}, this.state[objName]);
        statusCopy[inputName] = inputValue;

    if (inputName == 'idWorksite') {
      statusCopy.idProject = null;      
      statusCopy.idWorkSiteProject = null;
      statusCopy.idDivision = null; //RITM0617607
      statusCopy.idActivity = null; //RITM0617607
      statusCopy.idCompany = null;
      statusCopy.idCountry = null;
      statusCopy.idCustomer = null;
      statusCopy.division = '';
      statusCopy.company = '';
      statusCopy.country = '';
      statusCopy.customer = '';
    }

        if (inputName == 'idProject') {
            if (selectedItem) {
                let wksprj = this.state.listWorksitesPrj.find((el) => el.id == selectedItem.idWorksitePrj);

        statusCopy.idWorkSiteProject = wksprj.id;
                
        //RITM0497904
        const appActivity = wksprj?.idDivision ? this.props.appActivity.filter((el) => el.idDivision == wksprj?.idDivision) : null;
        statusCopy.idActivity = appActivity && appActivity.length > 0 ? appActivity[0]?.id : null;

        statusCopy.idDivision = wksprj.idDivision; //RITM0617607        
        statusCopy.idCompany = wksprj.idCompany;
        statusCopy.idCountry = wksprj.idCountry;
        statusCopy.idCustomer = wksprj.idCustomer;
        statusCopy.division = wksprj.division;
        statusCopy.company = wksprj.company;
        statusCopy.country = wksprj.country;
        statusCopy.customer = wksprj.customer;
      } else {
        statusCopy.idWorkSiteProject = null;
        statusCopy.idDivision = null; //RITM0617607
        statusCopy.idActivity = null; //RITM0617607
        statusCopy.idCompany = null;
        statusCopy.idCountry = null;
        statusCopy.idCustomer = null;
        statusCopy.division = '';
        statusCopy.company = '';
        statusCopy.country = '';
        statusCopy.customer = '';
      }
    }
    if (inputName == 'infoOriginator') {
      statusCopy.idSubContractor = null;
    }
    this.setState({ [objName]: statusCopy }, () => {
      this.loadRelatedProperties(inputName, inputValue, selectedItem);
    });
  };

    updateStateDP = (inputName, inputValue, objName) => {
        let statusCopy = Object.assign({}, this.state[objName]);
        statusCopy[inputName] = inputValue;

        if (inputName == 'occurrenceDate') {
            statusCopy.idWorksite = null;
            statusCopy.idProject = null;

            statusCopy.idWorkSiteProject = null;
            statusCopy.idDivision = null;
            statusCopy.idCompany = null;
            statusCopy.idCountry = null;
            statusCopy.idCustomer = null;
            statusCopy.idActivity = null;
            statusCopy.division = '';
            statusCopy.company = '';
            statusCopy.country = '';
            statusCopy.customer = '';
        }

        this.setState({ [objName]: statusCopy }, () => {
            this.loadRelatedProperties(inputName, inputValue);
        });
    };

    handleChangeOutcome = (value, id, event) => {
        if (value == false || value == 'false') {
            let realOutcomeRadio = null;
            if (id == 'outcomeAsset') realOutcomeRadio = 'realOutcomeAsset';
            else if (id == 'outcomeEnvironmental') realOutcomeRadio = 'realOutcomeEnvironmental';
            else if (id == 'outcomeHarm') realOutcomeRadio = 'realOutcomeHarm';

            if (realOutcomeRadio != null) this.updateState(realOutcomeRadio, null, 'incidentModel');
            }
        this.updateState(id, value, 'incidentModel');
    };

    handleChangeRadio = (value, id, event) => {
        if (value == 'true') {
            value = true;
        } else if (value == 'false') {

            // RITM1195257 commented Start
            // //RITM1063909
            // let emergencyClassRadio = null;
            // if (id == 'realOutcomeAsset' || id == 'realOutcomeEnvironmental' || id == 'realOutcomeHarm') emergencyClassRadio = 'emergencyClass';
            
            // if (emergencyClassRadio != null) this.updateState(emergencyClassRadio, '', 'incidentModel');
            // //End
            // RITM1195257 commented End
            // RITM1195257 added Start
            // let countryLCURadio = null;
            // if (id == 'realOutcomeAsset' || id == 'realOutcomeEnvironmental' || id == 'realOutcomeHarm') countryLCURadio = 'countryLCU';
            
            // if (countryLCURadio != null) this.updateState(countryLCURadio, '', 'incidentModel');
            // RITM1195257 added  End
            value = false;
        } else if (value == 'null') {
            value = null;
        }

        this.updateState(id, value, event.target.alt);
    };

    //RITM1405215
    handleChangePubAutEntInv = (selectedItem) => {
        const items = selectedItem ? selectedItem.selectedItems : null;
        const elements = items?.map((elem) => elem.id).join(',') || ''
        this.updateState(
            'publicAuthoritiesAndEntitiesInvolved',
            elements,
            'incidentModel'
        );
        let otherSelected = items?.find((el) => el.id == 'Other') || [];
        if (Object.keys(otherSelected).length == 0 && this.state.incidentModel.specifyOther !== '')
        this.updateState(
            'specifyOther',
            '',
            'incidentModel'
        );
    };
    //End

    handleChangeLifeSavingRules = (value, id) => {
        let inputName = 'lifeSavingRules';
        let oldValues = this.state.incidentModel[inputName] || [];

        let element = oldValues.find((el) => el.idLifeSavingRule == id);
        if (value && element == null) {
            // RITM0615447
            const savingRule = this.props.appLifeSavingRule.find(el => el.id == id)
            let obj = { id: uuid(), idIncident: undefined, idLifeSavingRule: id, isExclusive: savingRule.isExclusive };
            let newValues = obj.isExclusive ? [obj] : oldValues.concat([obj]);
            //FINE RITM0615447
            this.updateState(inputName, newValues, 'incidentModel');
            this.props.setlifeSavingRules(newValues);
        } else if (!value && element != null) {
            let newValues = oldValues.filter((el) => el.idLifeSavingRule != id);
            this.updateState(inputName, newValues, 'incidentModel');
            this.props.setlifeSavingRules(newValues);
        }       
    };

    //RITM1147493
    handleHighConsequenceLevel = (items, property, outcomeId, Actual, WC, Final) => { //RITM1216061
        //RITM1420951 
        // const statusCopy = { ...this.state.incidentModel }
        // const existOutcome = statusCopy.incidentOutcomes?.some(out => out.idOutcome == outcomeId)
        // const outcome = existOutcome ? statusCopy.incidentOutcomes?.find(out => out.idOutcome == outcomeId) : { idOutcome: outcomeId, idIncident: this.state.incidentModel.id }
        // outcome[property] = items
        // if (!existOutcome) statusCopy.incidentOutcomes ? statusCopy.incidentOutcomes.push(outcome) : statusCopy.incidentOutcomes = [outcome]
        
        // this.setState({ incidentModel: statusCopy })
        const statusCopy = {
            ...this.state.incidentModel,
            incidentOutcomes: [...(this.state.incidentModel.incidentOutcomes || [])]
        };
        const index = statusCopy.incidentOutcomes.findIndex(
            out => out.idOutcome === outcomeId
        );

        if (index >= 0) {
            statusCopy.incidentOutcomes[index] = {
                ...statusCopy.incidentOutcomes[index],
                [property]: items
            };
            } else {
            statusCopy.incidentOutcomes.push({
                idOutcome: outcomeId,
                idIncident: this.state.incidentModel.id,
                [property]: items
            });
        }

        this.setState({ incidentModel: statusCopy });
        //End

        // RITM1216061 
        if (outcomeId == 0 )//Harm
        {                
            this.setState({ PHLFinalValue: Final ,
                PHLWCValue: WC,
                AHLValue: Actual,
            });           
        }
        if (outcomeId == 2 )//Env
        {                
            this.setState({ PELFinalValue: Final ,
                PELWCValue: WC,
                AELValue: Actual,
            });
        }
        //RITM1216061 end
    }

    handleIncidentOutcomeBarrier = (items, property, outcomeId, barrierId) => {
        //RITM1420951
        // const statusCopy = { ...this.state.incidentModel }
        // const existOutcome = statusCopy.incidentOutcomes?.some(out => out.idOutcome == outcomeId)
        // const outcome = existOutcome ? statusCopy.incidentOutcomes?.find(out => out.idOutcome == outcomeId) : { idOutcome: outcomeId, idIncident: this.state.incidentModel.id }
        const statusCopy = {
            ...this.state.incidentModel,
            incidentOutcomes: [...(this.state.incidentModel.incidentOutcomes || [])]
        };
        const index = statusCopy.incidentOutcomes.findIndex(
            out => out.idOutcome === outcomeId
        );
        //End
        //outcome.incidentEffectiveInadequateBarrierGroups = effectiveInadequateBarrierGroupElements ?? []
        //outcome[property] = items
        //outcome.incidentEffectiveInadequateBarrierGroups ? outcome.incidentEffectiveInadequateBarrierGroups.push(...effectiveInadequateBarrierGroupElements ?? []) : outcome.incidentEffectiveInadequateBarrierGroups = [...effectiveInadequateBarrierGroupElements ?? []]
        if(property == 'incidentEffectiveInadequateBarrierGroups')
        {
            const newIncidentEffectiveInadequateBarrierGroup = []
            const newIncidentBarriers = []
            items.forEach((incidentEffectiveInadequateBarrierGroup) => {
                newIncidentEffectiveInadequateBarrierGroup.push({
                    ...incidentEffectiveInadequateBarrierGroup
                })
            })
            
            // const otherIncidentBarrierGroups = outcome[property]?.filter(x => x?.idBarrier !== barrierId).map(el => el) //RITM1420951
            const otherIncidentBarrierGroups = statusCopy.incidentOutcomes?.find((out => out.idOutcome == outcomeId))?.[property]?.filter(x => x?.idBarrier !== barrierId).map(el => el) //RITM1420951
            if(otherIncidentBarrierGroups && otherIncidentBarrierGroups.length > 0)
                otherIncidentBarrierGroups.forEach((incidentEffectiveInadequateBarrierGroup) => {
                    newIncidentEffectiveInadequateBarrierGroup.push({
                            ...incidentEffectiveInadequateBarrierGroup
                        })
                    })
            // const incidentBarriers = outcome['incidentBarriers']?.filter(x => items.find(el => el.incidentBarrierGroup.id == x?.incidentBarrier?.idIncidentBarrierGroup && el.idBarrier == x?.idBarrier)).map(elem => elem) //RITM1420951
            const incidentBarriers = statusCopy.incidentOutcomes?.find((out => out.idOutcome == outcomeId))?.['incidentBarriers']?.filter(x => items.find(el => el.incidentBarrierGroup.id == x?.incidentBarrier?.idIncidentBarrierGroup && el.idBarrier == x?.idBarrier)).map(elem => elem) //RITM1420951
            if (incidentBarriers && incidentBarriers.length > 0)
                incidentBarriers.forEach((incidentBarrier) => {
                    newIncidentBarriers.push({
                            ...incidentBarrier
                        })
                    })
            // const otherincidentBarriers = outcome['incidentBarriers']?.filter(x => x?.idBarrier !== barrierId).map(el => el) //RITM1420951
            const otherincidentBarriers = statusCopy.incidentOutcomes?.find((out => out.idOutcome == outcomeId))?.['incidentBarriers']?.filter(x => x?.idBarrier !== barrierId).map(el => el) //RITM1420951
            if (otherincidentBarriers && otherincidentBarriers.length > 0)
                otherincidentBarriers.forEach((incidentBarrier) => {
                    newIncidentBarriers.push({
                                ...incidentBarrier
                            })
                        })   
            //RITM1420951   
            // outcome[property] = [...newIncidentEffectiveInadequateBarrierGroup]
            // outcome['incidentBarriers'] =[...newIncidentBarriers]
            if (index >= 0) {
                statusCopy.incidentOutcomes[index] = {
                    ...statusCopy.incidentOutcomes[index],
                    [property]: [...newIncidentEffectiveInadequateBarrierGroup],
                    incidentBarriers: [...newIncidentBarriers]
                };
                } else {
                statusCopy.incidentOutcomes.push({
                    idOutcome: outcomeId,
                    idIncident: this.state.incidentModel.id,
                    [property]: [...newIncidentEffectiveInadequateBarrierGroup],
                    incidentBarriers: [...newIncidentBarriers]
                });
            }
            //End
        }
        else if (property == 'incidentBarriers')
        {
            const newIncidentBarriers = []
            const newIncidentEffectiveInadequateBarrierGroup = []
            items.forEach((incidentBarrier) => {
                    newIncidentBarriers.push({
                        ...incidentBarrier
                    })
                })

            // const otherincidentBarriers = outcome[property]?.filter(x => x?.idBarrier !== barrierId).map(el => el) //RITM1420951
            const otherincidentBarriers = statusCopy.incidentOutcomes?.find((out => out.idOutcome == outcomeId))?.[property]?.filter(x => x?.idBarrier !== barrierId).map(el => el) //RITM1420951
            if(otherincidentBarriers && otherincidentBarriers.length > 0)
                otherincidentBarriers.forEach((incidentBarrier) => {
                    newIncidentBarriers.push({
                                ...incidentBarrier
                            })
                        })

            // const incidentBarrierGroups = outcome['incidentEffectiveInadequateBarrierGroups']?.filter(x => items.find(el => el.incidentBarrier.idIncidentBarrierGroup == x?.incidentBarrierGroup?.id && el.idBarrier == x?.idBarrier)).map(elem => elem) //RITM1420951
            const incidentBarrierGroups =  statusCopy.incidentOutcomes?.find((out => out.idOutcome == outcomeId))?.['incidentEffectiveInadequateBarrierGroups']?.filter(x => items.find(el => el.incidentBarrier.idIncidentBarrierGroup == x?.incidentBarrierGroup?.id && el.idBarrier == x?.idBarrier)).map(elem => elem) //RITM1420951
            if (incidentBarrierGroups && incidentBarrierGroups.length > 0)
                incidentBarrierGroups.forEach((incidentEffectiveInadequateBarrierGroup) => {
                    newIncidentEffectiveInadequateBarrierGroup.push({
                                ...incidentEffectiveInadequateBarrierGroup
                            })
                        })

            // const otherincidentBarrierGroups = outcome['incidentEffectiveInadequateBarrierGroups']?.filter(x => x?.idBarrier !== barrierId).map(el => el) //RITM1420951 
            const otherincidentBarrierGroups = statusCopy.incidentOutcomes?.find((out => out.idOutcome == outcomeId))?.['incidentEffectiveInadequateBarrierGroups']?.filter(x => x?.idBarrier !== barrierId).map(el => el) //RITM1420951
            if (otherincidentBarrierGroups && otherincidentBarrierGroups.length > 0)
                otherincidentBarrierGroups.forEach((incidentEffectiveInadequateBarrierGroup) => {
                    newIncidentEffectiveInadequateBarrierGroup.push({
                                    ...incidentEffectiveInadequateBarrierGroup
                                })
                            })
            //RITM1420951
            // outcome[property] = [...newIncidentBarriers]
            // outcome['incidentEffectiveInadequateBarrierGroups'] =[...newIncidentEffectiveInadequateBarrierGroup] 
            if (index >= 0) {
                statusCopy.incidentOutcomes[index] = {
                    ...statusCopy.incidentOutcomes[index],
                    [property]: [...newIncidentBarriers],
                    incidentEffectiveInadequateBarrierGroups: [...newIncidentEffectiveInadequateBarrierGroup]
                };
                } else {
                statusCopy.incidentOutcomes.push({
                    idOutcome: outcomeId,
                    idIncident: this.state.incidentModel.id,
                    [property]: [...newIncidentBarriers],
                    incidentEffectiveInadequateBarrierGroups: [...newIncidentEffectiveInadequateBarrierGroup]
                });
            }
            //End     
        }
        
        //outcome[property] ? outcome[property].push(...items) : outcome[property] = [...items]
  
        // if (!existOutcome) statusCopy.incidentOutcomes ? statusCopy.incidentOutcomes.push(outcome) : statusCopy.incidentOutcomes = [outcome] //RITM1420951
        
        this.setState({ incidentModel: statusCopy })
    }

    //RITM1143712
    handleSpecifyOthersTypology = (el) => {
        let inputValue = el.target.value;
        let objName = el.target.alt;
        this.updateStateIT("specifyOther", inputValue, objName, "incidentTypologies");
    };

    onChange = (selectedItem) => {
        const items = selectedItem ? selectedItem.selectedItems : null;
        const element = items?.map((elem) =>({typology: elem, idTypology: elem.id})) || []
        this.updateStateIT("incidentTypologies", element, "incidentModel", null)
      };

    updateStateIT = (inputName, inputValue, objName, parentObjName) => {
        let statusCopy = Object.assign({}, this.state);
        let oldOthers = {};
        let newOthers = {};
        let woNewOthers = [];
        if (inputName == 'incidentTypologies')
        {
            newOthers = inputValue?.find(el => el?.typology?.name?.toLowerCase() === 'others') || {};
            woNewOthers = inputValue?.filter(el => el?.typology?.name?.toLowerCase() !== 'others') || inputValue;
            if (statusCopy[objName][inputName] !== undefined)
                oldOthers = statusCopy[objName][inputName].find(el => el.typology.name.toLowerCase() === 'others') || {};
            statusCopy[objName][inputName] = [...woNewOthers];
            if (Object.keys(oldOthers).length !== 0 && Object.keys(newOthers).length !== 0)
                statusCopy[objName][inputName].push(oldOthers);
            else if (Object.keys(oldOthers).length === 0 && Object.keys(newOthers).length !== 0)
                statusCopy[objName][inputName].push(newOthers);
        }
        if(inputName == 'specifyOther')
        {
            oldOthers = statusCopy[objName][parentObjName].find(el => el.typology.name.toLowerCase() === 'others') || {};
            if (Object.keys(oldOthers).length !== 0)
                oldOthers[inputName] = inputValue;
        }

        this.setState({ statusCopy });
    }
    //End

    //RITM1405215
    handleRealPotentialConsequenceLevel = (inputName, selectedItem, objName) => { 
        //RITM1420951
        const inputValue = selectedItem ? selectedItem.id : null;
        // const statusCopy = { ...this.state.incidentModel }
        // const existOutcome = statusCopy.incidentOutcomes?.some(out => out.idOutcome == INCIDENT_OUTCOME_ENUM["outcomeAsset"].idOutcome)
        // const outcome = existOutcome ? statusCopy.incidentOutcomes?.find(out => out.idOutcome == INCIDENT_OUTCOME_ENUM["outcomeAsset"].idOutcome) : { idOutcome: INCIDENT_OUTCOME_ENUM["outcomeAsset"].idOutcome, idIncident: this.state.incidentModel.id }
        // outcome[inputName] = inputValue
        // if (!existOutcome) statusCopy.incidentOutcomes ? statusCopy.incidentOutcomes.push(outcome) : statusCopy.incidentOutcomes = [outcome]
        
        // this.setState({ incidentModel: statusCopy })

        const statusCopy = {
            ...this.state.incidentModel,
            incidentOutcomes: [...(this.state.incidentModel.incidentOutcomes || [])]
        };
        const index = statusCopy.incidentOutcomes.findIndex(
            out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeAsset"].idOutcome
        );

        if (index >= 0) {
            statusCopy.incidentOutcomes[index] = {
                ...statusCopy.incidentOutcomes[index],
                [inputName]: inputValue
            };
            } else {
            statusCopy.incidentOutcomes.push({
                idOutcome: INCIDENT_OUTCOME_ENUM["outcomeAsset"].idOutcome,
                idIncident: this.state.incidentModel.id,
                [inputName]: inputValue
            });
        }

        this.setState({ incidentModel: statusCopy });
        //End
    }
    //End

    getIncidentType = () => {
        const valore =
            this.state.incidentModel.realOutcomeAsset == true ||
            this.state.incidentModel.realOutcomeEnvironmental == true ||
            this.state.incidentModel.realOutcomeHarm == true;

        return { isAccident: valore, text: valore ? 'Accident' : 'Near Miss' };
    };

    isCheckedPubAutEntInv = (id) => {
        const selectedValue = this.state.incidentModel.publicAuthoritiesAndEntitiesInvolved || '';
        let element = selectedValue.split(',').find((el) => el == id);
        return element != null;
    };

    getLifeSavingRuleByCategory = (list, idCategory) => {
        if (list == null) list = [];
        if (idCategory == null) return list;

        return list.filter((item) => item.idLifeSavingRuleCategory == idCategory /*RITM0615447*/ && item.id !== this.idNoViolationLifeSavingRule) || [];
    };

    renderIncidentLegenda = () => {
        return (
            <Accordion className="legenda">
                <AccordionItem className="" title="Legenda">
                    <TableContainer>
                        <Table className="legend-mobile">
                            <TableHead>
                                <TableRow>
                                    <TableHeader colSpan={9}>CONSEQUENCE</TableHeader>
                                </TableRow>
                                <TableRow>
                                    <TableHeader colSpan={1}>SEVERITY OF INCIDENT</TableHeader>
                                    <TableHeader colSpan={1}>INJURY TO PERSONS</TableHeader>
                                    <TableHeader colSpan={1}>DAMAGE TO ASSETS</TableHeader>
                                    <TableHeader colSpan={6}>EFFECTS ON ENVIRONMENT</TableHeader>
                                </TableRow>
                                <TableRow>
                                    <TableHeader colSpan={1}></TableHeader>
                                    <TableHeader colSpan={1}></TableHeader>
                                    <TableHeader colSpan={1}></TableHeader>
                                    <TableHeader colSpan={1}>SPATIAL EXTENSION</TableHeader>
                                    <TableHeader colSpan={1}>IMPACT ON HIGH VULNERABLE AREAS</TableHeader>
                                    <TableHeader colSpan={1}>CLEAN UP INTERVENTION/REMEDIATION</TableHeader>
                                    <TableHeader colSpan={1}>LOCAL COMMUNITIES IMPACT</TableHeader>
                                    <TableHeader colSpan={1}>REQUIREMENTS/AUTHORITIES</TableHeader>
                                    <TableHeader colSpan={1}>REPUTATIONAL IMPACT</TableHeader>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow key="1" className="gray">
                                    <TableCell key="1.1">1 Negligible</TableCell>
                                    <TableCell key="1.2">
                                        Slight injury or limited health effects(First Aid)
                  </TableCell>
                                    <TableCell key="1.3">
                                        Slight damage <br /> No disruption to operation
                  </TableCell>
                                    {/* RITM1102955 */}
                                    <TableCell key="1.4">
                                        Very Minor
                  </TableCell>
                                    <TableCell key="1.5">Not impacted</TableCell>
                                    <TableCell key="1.6">Managed with internal emergency team</TableCell>
                                    <TableCell key="1.7">Not impacted</TableCell>
                                    <TableCell key="1.8">Reporting not necessary</TableCell>
                                    <TableCell key="1.9">Not reported in the news</TableCell>
                                </TableRow>
                                <TableRow key="2" className="gray">
                                    <TableCell key="2.1">2 Low</TableCell>
                                    <TableCell key="2.2">
                                        Minor injury
                    <br /> Effects on health (Medical Treatment or Work restricted case)
                  </TableCell>
                                    <TableCell key="2.3">
                                        Minor damage <br /> Brief disruption (cost10K€-100K€ or 1day downtime)
                  </TableCell>
                                    {/* RITM1102955 */}
                                    <TableCell key="2.4">
                                        Minor pollution contained at site level and that doesn’t spread on the environmental media
                  </TableCell>
                                    <TableCell key="2.5">Not impacted</TableCell>
                                    <TableCell key="2.6">Managed with internal emergency team</TableCell>
                                    <TableCell key="2.7">Not impacted</TableCell>
                                    <TableCell key="2.8">Reported to Local authority without any fines</TableCell>
                                    <TableCell key="2.9">Not reported in the news</TableCell>
                                </TableRow>
                                <TableRow key="3" className="gray">
                                    <TableCell key="3.1">3 Medium</TableCell>
                                    <TableCell key="3.2">
                                        Serious injury or health effects or temporary or permanent total invalidity
                    <br /> (Lost Time Injury) <br />{' '}
                                    </TableCell>
                                    <TableCell key="3.3">
                                        Local damage <br /> Partial disruption (cost 100k€-500k€ or 1-7 days downtime)
                  </TableCell>
                                    {/* RITM1102955 */}
                                    <TableCell key="3.4">
                                        Pollution of the environmental media, up to a medium area (within the operational site, or at most within a few km) with short term effect
                  </TableCell>
                                    <TableCell key="3.5">Not impacted</TableCell>
                                    <TableCell key="3.6">Managed with internal emergency team</TableCell>
                                    <TableCell key="3.7">Might be impacted with no lasting effect</TableCell>
                                    <TableCell key="3.8">
                                        Reported to Local authority (Port Authority, etc) with negligible fines
                  </TableCell>
                                    <TableCell key="3.9">Reported in Local News</TableCell>
                                </TableRow>
                                <TableRow key="4" className="gray">
                                    <TableCell key="4.1">4 High</TableCell>
                                    <TableCell key="4.2">Single fatality </TableCell>
                                    <TableCell key="4.3">
                                        Major damage <br /> Major disruption(cost 500k€-3M€ or 1-2 weeks downtime)
                  </TableCell>
                                    {/* RITM1102955 */}
                                    <TableCell key="4.4">
                                        Pollution of the environmental media up to a vast area (beyond the site of the incident) with medium term effect
                  </TableCell>
                                    <TableCell key="4.5">Impacted with short term effect</TableCell>
                                    <TableCell key="4.6">Required the intervention of external facilities</TableCell>
                                    <TableCell key="4.7">
                                        Impacted with short term effect (up to few months effect)
                  </TableCell>
                                    <TableCell key="4.8">
                                        Reported to National authority (inspections, fines, stop of operations) with not
                                        negligible fines
                  </TableCell>
                                    <TableCell key="4.9">Reported in National News</TableCell>
                                </TableRow>
                                <TableRow key="5" className="gray">
                                    <TableCell key="5.1">5 Very High</TableCell>
                                    <TableCell key="5.2">Multiple fatalities</TableCell>
                                    <TableCell key="5.3">
                                        Extensive damage <br /> Very mayor disruption (cost 3M€-10M€ or more than 2
                    weeks downtime)
                  </TableCell>
                                    {/* RITM1102955 */}
                                    <TableCell key="5.4">
                                        Pollution of the environmental media up to a vast area (beyond the site of the incident) with long term effect
                  </TableCell>
                                    <TableCell key="5.5">Impacted with medium or long term effect</TableCell>
                                    <TableCell key="5.6">
                                        Required the intervention of external facilities or remediation not possible
                  </TableCell>
                                    <TableCell key="5.7">
                                        Impacted with medium or long term effect (significative time spawn effect)
                  </TableCell>
                                    <TableCell key="5.8">
                                        Reported to National authority (inspections, fines, stop of operations) with not
                                        negligible fines
                  </TableCell>
                                    <TableCell key="5.9">Reported in International News</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </AccordionItem>
            </Accordion>
        );
    };

    convertOccurrenceDate = (mode, value) => {
        if (mode) {
            let date = moment.utc(value);
            return {
                occurrenceDate: date.format('YYYY-MM-DD'),
                occurrenceTime: date.format('LT'),
            };
        }

        return moment
            .utc(
                this.state.incidentModel.occurrenceDate + ' ' + this.state.incidentModel.occurrenceTime,
                'YYYY-MM-DD LT'
            )
            .format();
    };

    saveTabNotification = async (send) => { //IP details counts error
        //RITM1216061 
         const FinalEnvValid = this.state.incidentModel.realOutcomeEnvironmental != null?
        (parseInt(this.state.PELFinalValue) <= parseInt(this.state.PELWCValue) && parseInt(this.state.PELFinalValue) >= parseInt(this.state.AELValue)) :true;
        
        const FinalHarmValid =  this.state.incidentModel.realOutcomeHarm != null?
        ((parseInt(this.state.PHLFinalValue) <= parseInt(this.state.PHLWCValue)) && parseInt(this.state.PHLFinalValue) >= parseInt(this.state.AHLValue)) :true;
    
        //RITM1216061 End
        if (this.validator.allValid()&& FinalHarmValid && FinalEnvValid ) {
           if (!this.validatorTime.allValid()){ //RITM1216061 
                if ((!this.props.isEdit && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) <= 1) 
                    || this.props.isEdit && this.state.incidentModel?.idStatus == 1 && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) <= 1) //RITM1519246
                {
                    alert("For PHCf final level 0 or 1 the investigation report is not required.\n Via the 'Consolidate Report' button in the top ribbon it is possible to consolidate the incident  with no further steps")
                }
                //IP details counts error
                let result = true;
                if (this.props.isEdit) 
                {
                    let realOutcomeHarm = this.state.incidentModel.realOutcomeHarm;
                    
                    let injuredPersonCount = this.props.tabInvestigation?.injuredPeople? this.props.tabInvestigation?.injuredPeople?.length : 0;
                    let noInjured = this.props.tabInvestigation.noInjured;
                    if ((realOutcomeHarm == false || realOutcomeHarm == null) && (injuredPersonCount > 0 || noInjured != null))
                    {
                        this.props.isSubmitted(true);

                        await api
                        .put('/incident/', null, `${this.state.incidentModel.id}/investigation/deleteinjuredperson`)
                        .then((response) => {
                            if (response.status == 200) {
                                let datiTabInvestigation = this.props.tabInvestigation;
                                datiTabInvestigation.injuredPeople = [];
                                datiTabInvestigation.noInjured = null;
                                this.props.updateIncidentTabInvestigationModel(datiTabInvestigation);
                            } else {
                            showNotification.error();
                            result = false;
                            }
                        })
                        .catch((error) => {
                            showNotification.error(
                            `${entitiesLabels.ERROR}`,
                            getError(error, entitiesLabels.INJUREDPEROSN, apioperation.PUT)
                            );
                            result = false;
                        }).finally(() => {
                            this.props.isSubmitted(false);
                        });
                    }
                }
                if (!result)
                    return;
                //End

                this.props.isSubmitted(true); //IP details counts error

                let datiForm = this.state.incidentModel;
                datiForm.type = this.getIncidentType().text;
                datiForm.occurrenceDate = this.convertOccurrenceDate(0);
                if (!datiForm.realOutcomeAsset && !datiForm.realOutcomeEnvironmental && !datiForm.realOutcomeHarm) {
                    datiForm.emergencyClass = '';
                    datiForm.countryLCU = ''; // RITM1195257 added countryLCU
                    datiForm.transportAccident = '';
                    datiForm.publicAuthoritiesAndEntitiesInvolved = '';
                }
                if (!this.props.isEdit) {
                    datiForm.id = uuid();
                }
                if (!this.props.isEdit && this.state.incidentModel.attachmentNotifications.length > 0) {
                    this.state.incidentModel.attachmentNotifications.map(
                        (atta) => (atta.idIncident = datiForm.id)
                    );
                }
                /* RITM0655780 */
                let method;
                if (send === true) {
                    method = this.props.isEdit
                        ? api.put('/incident/', datiForm, datiForm.id + '/notification')
                        : api.post('/incident/', datiForm);
                } else {
                    method = this.props.isEdit
                        ? api.put('/incident/', datiForm, datiForm.id + '/notification/onlysave')
                        : api.post('/incident/onlysave', datiForm);
                }
                /* END RITM0655780 */

                method
                    .then((response) => {
                        if (response.status == 200) {
                            var resp = response.data;
                            // showNotification.success(this.state.incidentModel.id != null ? getSuccess(entitiesLabels.INCIDENT, apioperation.PUT) : getSuccess(entitiesLabels.INCIDENT, apioperation.POST));
                            // if (!this.props.isEdit) {
                            //     this.props.history.push('/incident/' + resp.id);
                            // } else {
                            //     this.props.updateType(datiForm);
                            // }
                            //modifica offline
                            let idIncidentReport = datiForm.incidentReportId !== null ? datiForm.incidentReportId : response.data.incidentReportId;
                            let notificationDateIncidentReport = datiForm.notificationDate !== null ? datiForm.notificationDate : response.data.notificationDate;
                            let realOutcomeHarm = datiForm.realOutcomeHarm !== null ? datiForm.realOutcomeHarm : response.data.realOutcomeHarm; //RITM1100465
                            if(send === false){
                                if(idIncidentReport === null){
                                    //Visualizza la conferma del salvataggio se la notifica non è stata ancora inviata alla creazione
                                    showNotification.warning(
                                        `${entitiesLabels.WARNING}`,
                                        `${entitiesLabels.INCIDENT} ${entitiesLabels.WITHCODE} ${getSuccess(
                                            idIncidentReport,
                                            apioperation.POST
                                        )} but the notification has not been sent yet!`
                                    )
                                }                                
                                else if(notificationDateIncidentReport === null || notificationDateIncidentReport === '0001-01-01T00:00:00Z'){
                                    //Visualizza la conferma del salvataggio se la notifica non è stata ancora inviata alla modifica
                                    showNotification.warning(
                                        `${entitiesLabels.WARNING}`,
                                        `${entitiesLabels.INCIDENT} ${entitiesLabels.WITHCODE} ${getSuccess(
                                            idIncidentReport,
                                            apioperation.PUT
                                        )} but the notification has not been sent yet!`
                                    )
                                }
                                else{
                                    //Visualizza la conferma del salvataggio se la notifica è stata già inviata alla modifica
                                    showNotification.success(
                                        `${entitiesLabels.SUCCESS}`,
                                        `${entitiesLabels.INCIDENT} ${entitiesLabels.WITHCODE} ${getSuccess(
                                            idIncidentReport,
                                            apioperation.PUT
                                        )}`
                                    );
                                }
                            }
                            else{
                                if(idIncidentReport === null){
                                    //Visualizza la conferma del salvataggio se la notifica è stata inviata alla creazione
                                    //RITM1100465
                                    if (resp.notificationDate  === '0001-01-01T00:00:00Z' && !realOutcomeHarm)
                                    {
                                        showNotification.warning(
                                            `${entitiesLabels.WARNING}`,
                                            `${entitiesLabels.INCIDENT} ${entitiesLabels.WITHCODE} ${getSuccess(
                                                idIncidentReport,
                                                apioperation.POST
                                            )} but the notification has not been sent due to an exception. Please try again later`
                                        )
                                    }
                                    else{
                                        showNotification.success(
                                            `${entitiesLabels.SUCCESS}`,
                                            `${entitiesLabels.INCIDENT} ${entitiesLabels.WITHCODE} ${getSuccess(
                                                idIncidentReport,
                                                apioperation.POST
                                            )}`
                                        );
                                    }
                                    //End
                                }   
                                else{
                                    //RITM1100465
                                    if (resp.notificationDate  === '0001-01-01T00:00:00Z' && !realOutcomeHarm || (resp.notificationDate  === '0001-01-01T00:00:00Z' && realOutcomeHarm && (resp.injuredPeople? resp.injuredPeople?.length : 0) > 0))
                                    {
                                        showNotification.warning(
                                            `${entitiesLabels.WARNING}`,
                                            `${entitiesLabels.INCIDENT} ${entitiesLabels.WITHCODE} ${getSuccess(
                                                idIncidentReport,
                                                apioperation.PUT
                                            )} but the notification has not been sent due to an exception. Please try again later`
                                        )
                                    }
                                    else{
                                        showNotification.success(
                                            `${entitiesLabels.SUCCESS}`,
                                            `${entitiesLabels.INCIDENT} ${entitiesLabels.WITHCODE} ${getSuccess(
                                                idIncidentReport,
                                                apioperation.PUT
                                            )}`
                                        );
                                    }
                                    //End
                                }                                
                            }

                            if (!this.props.isEdit) {
                                //todo aggiornare il modello dati con le props mancanti
                                //this.props.history.push('/incident/' + datiForm.id);
                                datiForm['idCompiler'] = this.props.user.id;
                                datiForm['idStatus'] = 1;
                                datiForm['status'] = {
                                    caManagementName: 'Draft',
                                    carManagementName: 'Assigned',
                                    id: 1,
                                    name: 'Draft',
                                    planningName: 'Draft',
                                    reportingName: 'Opened',
                                };

                                datiForm['progressiveId'] = 0;
                                datiForm['incidentReportId'] = null;
                                //notificationDate
                                //processed
                            }

                            if(send === true){
                                datiForm['notificationDate'] = resp.notificationDate;
                            }

                            this.props.updateCacheIncidentModel(datiForm, 'tabNotifications');
                            this.props.onChange(
                                this.state.incidentModel.outcomeAsset,
                                this.state.incidentModel.outcomeEnvironmental,
                                this.state.incidentModel.outcomeHarm,
                                this.state.incidentModel.realOutcomeHarm,
                                this.state.incidentModel.realOutcomeAsset, //RITM1069073
                            );

                            //RITM0615454_DEV615_MatriciOutcomes
                            const statusCopy = { ...this.state.incidentModel }
                            statusCopy.idInvestigationLevelPotentialConsequenceProbability = resp.idInvestigationLevelPotentialConsequenceProbability;
                            statusCopy.idInvestigationLevelPotentialConsequenceSeverity = resp.idInvestigationLevelPotentialConsequenceSeverity;
                            statusCopy.idInvestigationLevelRealConsequenceSeverity = resp.idInvestigationLevelRealConsequenceSeverity;
                            statusCopy.idInvestigation = resp.idInvestigation;
                            this.setState({ incidentModel: statusCopy })
                            //RITM0864430
                            let injuredPersonCount = resp.injuredPeople? resp.injuredPeople?.length : 0;
                            if (send === true && this.state.incidentModel.realOutcomeHarm === true && injuredPersonCount === 0){
                                this.props.updateAutoOpenInjuredPerson(true);
                                if (!this.props.isEdit)
                                    {
                                        this.props.updateEditMode(resp.id);
                                    }
                                this.selectTab(1);
                            } 
                        } else {
                            showNotification.error();
                        }
                    })
                    .catch((error) => {
                        //RITM0615454_DEV615_MatriciOutcomes
                        //const isOutcomeTableError = error.response.data.includes("table") ?? false
                        const isOutcomeTableError = (error.response.data.includes("table") || error.response.data.includes("outcome")) ?? false

                        if (isOutcomeTableError) showNotification.warning(`${entitiesLabels.WARNING}`, error.response.data)
                        else showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.INCIDENT, apioperation.POST))
                    })
                    .finally(() => {
                        this.props.isSubmitted(false);
                    });
            } else {
                this.validator.showMessages();
                showNotification.warning(
                    `${entitiesLabels.WARNING}`,
                    entitiesLabels.INCIDENT + ' Time is invalid '
                );
                this.forceUpdate();
            }
        } else {
            var msg = !FinalHarmValid ? "Error! PHCf_people value must be equal to / less than PHCwc_people and equal to / greater than AHC_people value. " : " ";//RITM1216061 
            msg = !FinalEnvValid ? msg + " Error! PHCf_env value must be equal to / less than PHCwc_env and equal to / greater than AHC_env value" : msg + " ";//RITM1216061 
             showNotification.warning(`${entitiesLabels.WARNING}`, msg)
             if(!this.validator.allValid())
             {				                     
                this.validator.showMessages();
                showNotification.warning(
                    `${entitiesLabels.WARNING}`,
                    entitiesLabels.INCIDENT + ' required fields are missing  '
                );
            this.forceUpdate();
             }
         }
    };

    isLifeSavingRulesDisabled = (idSavingRule) => {
        if (this.state.isDisabled) return true
   
        const selectedLifeSavingRules = this.state.incidentModel.lifeSavingRules?.map(el => this.props.appLifeSavingRule?.find(x => x.id === el.idLifeSavingRule)) ?? []
        if (selectedLifeSavingRules.length === 0) return false
   
        const isSomeExlusiveSelected = selectedLifeSavingRules.some((el) => el.isExclusive)
        const isThisSelected = selectedLifeSavingRules.find((el) => el.id == idSavingRule) ?? false
        return isSomeExlusiveSelected && !isThisSelected
    }

    returnTypologies = (id) => this.state.incidentModel.incidentTypologies?.find(el => el.idTypology == id) ? true : false //RITM1143712
    //RITM1405215
    returnPubAutEntInvs = (id) => {
        let selectedValues = this.state.incidentModel.publicAuthoritiesAndEntitiesInvolved;
        let array = selectedValues ? selectedValues.split(',') : [];
        return array?.find(el => el == id) ? true : false 
    }
    getIncidentHighConsequenceLevel() {
        const outcomeharm =this.state.incidentModel?.incidentOutcomes?.find(out => out.idOutcome ==0);
        const outcomeEnv =this.state.incidentModel?.incidentOutcomes?.find(out => out.idOutcome ==2);
        this.setState({
            PELFinalValue : outcomeEnv != null ? (this.props.appHighConsequenceLevels.find((el) => el.id == outcomeEnv.idHighConsequenceLevelPotentialFinal)?.ranking) : null,
            PHLFinalValue : outcomeharm != null ? (this.props.appHighConsequenceLevels.find((el) => el.id == outcomeharm.idHighConsequenceLevelPotentialFinal)?.ranking) : null,
            PELWCValue :  outcomeEnv != null ? (this.props.appHighConsequenceLevels.find((el) => el.id == outcomeEnv.idHighConsequenceLevelPotentialWorstCase)?.ranking) : null,
            PHLWCValue : outcomeharm != null ? (this.props.appHighConsequenceLevels.find((el) => el.id == outcomeharm.idHighConsequenceLevelPotentialFinal)?.ranking) :null,
            AELValue :  outcomeEnv != null ? (this.props.appHighConsequenceLevels.find((el) => el.id == outcomeEnv.idHighConsequenceLevelActual)?.ranking) : null,
            AHLValue : outcomeharm != null ? (this.props.appHighConsequenceLevels.find((el) => el.id == outcomeharm.idHighConsequenceLevelActual)?.ranking) : null,
        });          
    }

    //RITM1519246
    getphcfLevel = (phlFinalValue, pelFinalValue) => {
        if (phlFinalValue == null && pelFinalValue == null) return null;
        const phcf = (phlFinalValue == null && pelFinalValue != null) ? parseInt(pelFinalValue) : ((phlFinalValue != null && pelFinalValue == null) ? parseInt(phlFinalValue) : Math.max(parseInt(phlFinalValue), parseInt(pelFinalValue)));
        return !Number.isNaN(phcf) ? phcf : null;
    };
    //End

    render() {
        const typeIncident = this.getIncidentType();
        const probabilities = this.props.appProbabilities || [];
        const appActivity = this.state.incidentModel.idDivision
            ? this.props.appActivity.filter((el) => el.idDivision == this.state.incidentModel.idDivision)
            : null;
        const showSpecifyOther = this.isCheckedPubAutEntInv('Other');
        const appProject = this.state.appProject;
        const appWorksites = this.state.appWorksites;
        //RITM1197573
        const subContractorsByInfo = this.state.incidentModel?.infoOriginator
            ? (this.props.subContractors || []).filter(
                (el) => (el.inUse || el.id == this.state.incidentModel?.idSubContractor) && el.infoOriginator?.name == this.state.incidentModel?.infoOriginator
            )
            : [];
        //RITM1143712
        const appIncidentTypology = (this.props.appIncidentTypology || []).filter(
            (el) => (el.inUse) || this.state.incidentModel?.incidentTypologies?.find(elem => elem?.idTypology == el.id));
        //RITM1197573
        const appInfoOriginator = (this.props.appInfoOriginator || []).filter(
                (el) => (el.inUse) || this.state.incidentModel?.infoOriginator == el.id);
        const selectedItemCombo = {
            idWorksite: (appWorksites || []).find((el) => el.id == this.state.incidentModel.idWorksite),
            idProject: (appProject || []).find((el) => el.id == this.state.incidentModel.idProject),
            idActivity: (appActivity || []).find((el) => el.id == this.state.incidentModel.idActivity),
            transportAccident: (this.props.appTransportAccident || []).find(
                (el) => el.id == this.state.incidentModel.transportAccident
            ),
            infoOriginator: (appInfoOriginator || []).find( //RITM1197573
                (el) => el.id == this.state.incidentModel?.infoOriginator
            ),
            subContractor: (subContractorsByInfo || {}).find(
                (el) => el.id == this.state.incidentModel?.idSubContractor
            ),
            workRelated: (this.props.appWorkRelated || []).find(
                (el) => el.id == this.state.incidentModel.workRelated
            ),
            place: (this.props.appPlace || []).find((el) => el.id == this.state.incidentModel.place),
            //RITM1143712
            selectedTypologies: (appIncidentTypology || []).filter(
                (el) =>this.returnTypologies(el.id)),
            //RITM1405215
            selectedPubAutEntInv: (this.props.appPublicAuthoritiesAndEntitiesInvolved || []).filter(
                (el) =>this.returnPubAutEntInvs(el.id)),
            //RITM1405215
            realConsequence: (this.props.appRealPotentialConsequenceLevels || []).find(
                (el) => el.id == this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeAsset"].idOutcome)?.idRealConsequenceLevel),
            potentialConsequence: (this.props.appRealPotentialConsequenceLevels || []).find(
                    (el) => el.id == this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeAsset"].idOutcome)?.idPotentialConsequenceLevel),
        };

        const showOtherTypology = selectedItemCombo.selectedTypologies.find(el => el.name.toLowerCase() === 'others')?.specifyOther; //RITM1143712

        const showTransportAccidentEquipped =
            selectedItemCombo.transportAccident != null &&
            selectedItemCombo.transportAccident.specifyOther == true; // this.state.incidentModel.transportAccident == 'RoadTraffic';
        const showIsWorkRelatedCommunting =
            selectedItemCombo.workRelated != null && selectedItemCombo.workRelated.specifyOther == true; //this.state.incidentModel.workRelated == 'Communting';
        this.validator.purgeFields(); //si usa quando ci sono validazioni condizionali tra più campi

        const validationsTime = {
            validTime: this.validatorTime.message('validTime', this.state.flagTime, 'accepted'),
        };
        const validations = {
            occurrenceDate: this.validator.message(
                'occurrenceDate',
                this.state.incidentModel.occurrenceDate,
                'required'
            ),
            occurrenceTime: this.validator.message(
                'occurrenceTime',
                this.state.incidentModel.occurrenceTime,
                'required'
            ),

            idWorksite: this.validator.message(
                'Worksite',
                this.state.incidentModel.idWorksite,
                'required'
            ),
            idProject: this.validator.message(
                'Project',
                this.state.incidentModel.idProject,
                'required'
            ),
            idActivity: this.validator.message(
                'Activity',
                this.state.incidentModel.idActivity,
                'required'
            ),
            outcome: this.validator.message(
                'outcome',
                this.state.incidentModel.outcomeAsset ||
                this.state.incidentModel.outcomeEnvironmental ||
                this.state.incidentModel.outcomeHarm,
                'accepted'
            ),
            specifyOther: this.validator.message(
                'specifyOther',
                showSpecifyOther == true && this.state.incidentModel.specifyOther,
                'required'
            ),
            infoOriginator: this.validator.message(
                'infoOriginator',
                this.state.incidentModel.infoOriginator,
                'required'
            ),
            subContractor: this.validator.message(
                'idSubContractor',
                this.state.incidentModel?.infoOriginator === 'Saipem'
                    ? true
                    : this.state.incidentModel.idSubContractor,
                'required'
            ),
            realOutcomeAsset: this.validator.message(
                'realOutcomeAsset',
                !this.state.incidentModel.outcomeAsset || this.state.incidentModel.realOutcomeAsset != null,
                'accepted'
            ),
            realOutcomeEnvironmental: this.validator.message(
                'realOutcomeEnvironmental',
                !this.state.incidentModel.outcomeEnvironmental ||
                this.state.incidentModel.realOutcomeEnvironmental != null,
                'accepted'
            ),
            realOutcomeHarm: this.validator.message(
                'realOutcomeHarm',
                !this.state.incidentModel.outcomeHarm || this.state.incidentModel.realOutcomeHarm != null,
                'accepted'
            ),
            title: this.validator.message('title', this.state.incidentModel.title, 'required'),
            workRelated: this.validator.message(
                'work Related',
                this.state.incidentModel.workRelated,
                'required'
            ),
            place: showIsWorkRelatedCommunting
                ? this.validator.message('place', this.state.incidentModel.place, 'required')
                : null,
            companyVehicleProvided: showIsWorkRelatedCommunting
                ? this.validator.message(
                    'companyVehicleProvided',
                    this.state.incidentModel.companyVehicleProvided != null,
                    'accepted'
                )
                : null,
            //RITM1147493
            highConsequenceLevelActualHarm: (this.state.incidentModel.realOutcomeHarm != null && this.state.incidentModel.realOutcomeHarm == false) ? (null) : (this.validator.message("Actual High Consequence Level", (this.state.incidentModel.outcomeAsset && !this.state.incidentModel.outcomeHarm) ? true : !this.state.incidentModel.outcomeHarm || this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeHarm"].idOutcome)?.idHighConsequenceLevelActual, "required")),//RITM1216061 
            highConsequenceLevelPotentialWorstCaseHarm: this.validator.message("Potential High Consequence Level Worst Case", (this.state.incidentModel.outcomeAsset && !this.state.incidentModel.outcomeHarm) ? true : !this.state.incidentModel.outcomeHarm || this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeHarm"].idOutcome)?.idHighConsequenceLevelPotentialWorstCase, "required"),
            effectiveBarrierGroupHarm: this.validator.message("Effective Barrier Groups High-Consequence Level", (this.state.incidentModel.outcomeAsset && !this.state.incidentModel.outcomeHarm) ? true : !this.state.incidentModel.outcomeHarm || (this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeHarm"].idOutcome)?.incidentEffectiveInadequateBarrierGroups || []).filter((item) => item.idBarrier === 0)[0], "required"),
            effectiveBarrierHarm: this.validator.message("Effective Barrier High-Consequence Level", (this.state.incidentModel.outcomeAsset && !this.state.incidentModel.outcomeHarm) ? true : !this.state.incidentModel.outcomeHarm || (this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeHarm"].idOutcome)?.incidentBarriers || []).filter((item) => item.idBarrier === 0)[0], "required"),
            inadequateBarrierGroupHarm: this.validator.message("Inadequate Barrier Groups High-Consequence Level", (this.state.incidentModel.outcomeAsset && !this.state.incidentModel.outcomeHarm) ? true : !this.state.incidentModel.outcomeHarm || (this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeHarm"].idOutcome)?.incidentEffectiveInadequateBarrierGroups || []).filter((item) => item.idBarrier === 1)[0], "required"),
            inadequateBarrierHarm: this.validator.message("Inadequate Barrier High-Consequence Level", (this.state.incidentModel.outcomeAsset && !this.state.incidentModel.outcomeHarm) ? true : !this.state.incidentModel.outcomeHarm || (this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeHarm"].idOutcome)?.incidentBarriers || []).filter((item) => item.idBarrier === 1)[0], "required"),
            highConsequenceLevelPotentialFinalHarm: this.validator.message("Potential High Consequence Level Final", (this.state.incidentModel.outcomeAsset && !this.state.incidentModel.outcomeHarm) ? true : !this.state.incidentModel.outcomeHarm || this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeHarm"].idOutcome)?.idHighConsequenceLevelPotentialFinal, "required"),

            highConsequenceLevelActualEnv: (this.state.incidentModel.realOutcomeEnvironmental != null && this.state.incidentModel.realOutcomeEnvironmental == false) ? (null) : (this.validator.message("Actual Environmental Level", (this.state.incidentModel.outcomeAsset && !this.state.incidentModel.outcomeEnvironmental) ? true : !this.state.incidentModel.outcomeEnvironmental || this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeEnvironmental"].idOutcome)?.idHighConsequenceLevelActual, "required")),//RITM1216061 
            highConsequenceLevelPotentialWorstCaseEnv: this.validator.message("Potential Environmental Level Worst Case", (this.state.incidentModel.outcomeAsset && !this.state.incidentModel.outcomeEnvironmental) ? true : !this.state.incidentModel.outcomeEnvironmental || this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeEnvironmental"].idOutcome)?.idHighConsequenceLevelPotentialWorstCase, "required"),
            effectiveBarrierGroupEnv: this.validator.message("Effective Barrier Groups Environmental Level", (this.state.incidentModel.outcomeAsset && !this.state.incidentModel.outcomeEnvironmental) ? true : !this.state.incidentModel.outcomeEnvironmental || (this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeEnvironmental"].idOutcome)?.incidentEffectiveInadequateBarrierGroups || []).filter((item) => item.idBarrier === 0)[0], "required"), //RITM1405215
            effectiveBarrierEnv: this.validator.message("Effective Barrier Environmental Level", (this.state.incidentModel.outcomeAsset && !this.state.incidentModel.outcomeEnvironmental) ? true : !this.state.incidentModel.outcomeEnvironmental || (this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeEnvironmental"].idOutcome)?.incidentBarriers || []).filter((item) => item.idBarrier === 0)[0], "required"),
            inadequateBarrierGroupEnv: this.validator.message("Inadequate Barrier Groups Environmental Level", (this.state.incidentModel.outcomeAsset && !this.state.incidentModel.outcomeEnvironmental) ? true : !this.state.incidentModel.outcomeEnvironmental || (this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeEnvironmental"].idOutcome)?.incidentEffectiveInadequateBarrierGroups || []).filter((item) => item.idBarrier === 1)[0], "required"),
            inadequateBarrierEnv: this.validator.message("Inadequate Barrier Environmental Level", (this.state.incidentModel.outcomeAsset && !this.state.incidentModel.outcomeEnvironmental) ? true : !this.state.incidentModel.outcomeEnvironmental || (this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeEnvironmental"].idOutcome)?.incidentBarriers || []).filter((item) => item.idBarrier === 1)[0], "required"),
            highConsequenceLevelPotentialFinalEnv: this.validator.message("Potenial Environmental Level Final)", (this.state.incidentModel.outcomeAsset && !this.state.incidentModel.outcomeEnvironmental) ? true : !this.state.incidentModel.outcomeEnvironmental || this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeEnvironmental"].idOutcome)?.idHighConsequenceLevelPotentialFinal, "required"),
            //End
            incidentTypology: this.validator.message("Incident Typology", (this.state.incidentModel?.incidentTypologies || [])[0], "required"), //RITM1143712
            incidentTypologySpecifyOther: this.validator.message("Incident Typology Specify Other", showOtherTypology == true && (this.state.incidentModel?.incidentTypologies || []).find(el => el?.typology?.name?.toLowerCase() == 'others')?.specifyOther, "required"), //RITM1143712
            //matrix
            // { this.incidentModel.idInvestigationLevelRealConsequenceSeverity }

            //RITM0615454_DEV615_MatriciOutcomes - adesso questi valori vengono calcolati da BE
            // idInvestigationLevelRealConsequenceSeverity: this.validator.message(
            //   'idInvestigationLevelRealConsequenceSeverity',
            //   this.state.incidentModel.idInvestigationLevelRealConsequenceSeverity != null,
            //   'accepted'
            // ),
            // idInvestigationLevelPotentialConsequenceSeverity: this.validator.message(
            //   'idInvestigationLevelPotentialConsequenceSeverity',
            //   this.state.incidentModel.idInvestigationLevelPotentialConsequenceSeverity != null,
            //   'accepted'
            // ),
            //FINE //RITM0615454_DEV615_MatriciOutcomes
            // lifeSavingRules: this.validator.message(
            //     'Life Saving Rules',
            //     this.state.incidentModel.lifeSavingRules != null ? this.state.incidentModel.lifeSavingRules[0]: null,
            //     'required'
            // ),
            // NF ID: RITM1216061 || Task - 1 || Sub-Task-3 || Vasudevan //RITM1519246
            lifeSavingRules: this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) != null && this.getphcfLevel(this.state.PHLFinalValue, this.state.PELFinalValue) <= 1 ? this.validator.message(
                    'Life Saving Rules',
                    this.state.incidentModel?.lifeSavingRules?.[0] ?? null,
                    'required'
                )
                : null,
               
            mailTo: this.validator.message('mailTo', this.state.incidentModel.mailTo, 'required'),
            mailBody: this.validator.message('mailBody', this.state.incidentModel.mailBody, 'required'),
             // RITM1195257 commented start
            // //RITM1063909
            // emergencyClass: this.validator.message(
            //     'emergencyClass',
            //     ((this.state.incidentModel.realOutcomeHarm == true || this.state.incidentModel.realOutcomeAsset == true || this.state.incidentModel.realOutcomeEnvironmental == true) 
            //     && this.state.incidentModel.emergencyClass != '' || (this.state.incidentModel.realOutcomeHarm == false || this.state.incidentModel.realOutcomeAsset == false || this.state.incidentModel.realOutcomeEnvironmental == false)),
            //     'accepted'
            // ),
            // //End
            // RITM1195257 commented End
               // RITM1195257 added countryLCU start
               countryLCU: this.validator.message(
                'countryLCU',
                (((this.state.incidentModel.realOutcomeHarm == true || this.state.incidentModel.realOutcomeAsset == true || this.state.incidentModel.realOutcomeEnvironmental == true) 
                && this.state.incidentModel.countryLCU != null && this.state.incidentModel.countryLCU != '') || ((this.state.incidentModel.realOutcomeHarm == false || this.state.incidentModel.realOutcomeHarm == null) && (this.state.incidentModel.realOutcomeAsset == false || this.state.incidentModel.realOutcomeAsset == null) && (this.state.incidentModel.realOutcomeEnvironmental == false || this.state.incidentModel.realOutcomeEnvironmental == null))),
                'accepted'
            ),
            // RITM1195257 added countryLCU End
            //RITM1405215
            realConsequence: this.validator.message('realConsequence', !this.state.incidentModel.outcomeAsset ? true : this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeAsset"].idOutcome)?.idRealConsequenceLevel, 'required'),
            potentialConsequence: this.validator.message('potentialConsequence', !this.state.incidentModel.outcomeAsset ? true : this.state.incidentModel?.incidentOutcomes.find(out => out.idOutcome === INCIDENT_OUTCOME_ENUM["outcomeAsset"].idOutcome)?.idPotentialConsequenceLevel, 'required'),
        };
        
        //RITM0615454_DEV615_MatriciOutcomes
        const outcomeProperty = Object.keys(INCIDENT_OUTCOME_ENUM).find(outcomeName => INCIDENT_OUTCOME_ENUM[outcomeName].idOutcome === this.state.outcomeTab)
        const selectedOutcome = outcomeProperty ? { ...INCIDENT_OUTCOME_ENUM[outcomeProperty], propertyName: outcomeProperty } : null

        // RITM0615447
        const NoViolationLSR = this.props.appLifeSavingRule?.find(el => el.id === this.idNoViolationLifeSavingRule)

        return (
            <>
                <div className="bx--row">
                    <div className="padding-progress-indicator-vertical hidden-box">
                        <Menu>
                            <Item section="eventdetail">1.1 Event Detail</Item>
                            <Item section="generaldata">1.2 Incident Description</Item>
                            <Item section="incidentdescription">1.3 General Data</Item>
                        </Menu>
                    </div>
                    <div className="bx--col-lg-10 bx--col-md-10 margin-progress-indicator-vertical">
                        <Section id="eventdetail" className="section--title">
                            <div>
                                <h3 className="title--medium--expressive">1.1 Event Details</h3>
                            </div>

                            <div className="bx--row section--title">
                                <div className="bx--col-lg-6 bx--col-md-4">
                                    <FormGroup key="date-picker-occ" legendText="Occurence Date*">
                                        <DateTimePicker
                                            value={this.state.incidentModel.occurrenceDate}
                                            type="date"
                                            placeholder={DateFormat}
                                            name="occurrenceDate"
                                            alt="incidentModel"
                                            invalid={validations.occurrenceDate != null}
                                            onChange={this.updateStateDP}
                                            disabled={this.state.isDisabled}
                                        />

                                        {validations.occurrenceDate}
                                    </FormGroup>
                                </div>
                                <div className="bx--col-lg-6 bx--col-md-4 ">
                                    <FormGroup key="occurrenceTime" legendText="Time*">
                                        <DateTimePicker
                                            maxLength={8}
                                            value={this.state.incidentModel.occurrenceTime}
                                            type="time"
                                            placeholder="hh:mm AM/PM"
                                            name="occurrenceTime"
                                            alt="incidentModel"
                                            invalid={validations.occurrenceTime != null}
                                            onChange={this.updateStatesTime}
                                            disabled={this.state.isDisabled}
                                        />
                                        {validations.occurrenceTime}
                                        {this.state.flagTime ? (
                                            <div className="srv-validation-message "> Invalid time format </div>
                                        ) : null}
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="bx--row">
                                <div className="bx--col-lg-6 bx--col-md-4">
                                    <FormGroup legendText="Worksite*">
                                        <ComboBox
                                            id="idWorksite"
                                            key={'idWorksite_' + appWorksites?.length + this.state.incidentModel.occurrenceDate}
                                            placeholder="Select"
                                            name="idWorksite"
                                            alt="incidentModel"
                                            onChange={this.handleChangeCombo}
                                            itemToString={(item) => (item ? item.name : '')}
                                            initialSelectedItem={selectedItemCombo.idWorksite}
                                            items={appWorksites}
                                            disabled={appWorksites == null || this.state.isDisabled}
                                            invalid={validations.idWorksite != null}
                                        />
                                        {validations.idWorksite}
                                    </FormGroup>
                                </div>
                                <div className="bx--col-lg-6 bx--col-md-4">
                                    <FormGroup legendText="PRJ*">
                                        <ComboBox
                                            id="idProject"
                                            key={'idProject_' + selectedItemCombo.idProject + selectedItemCombo.idWorksite}
                                            placeholder="Select"
                                            name="idProject"
                                            alt="incidentModel"
                                            onChange={this.handleChangeCombo}
                                            itemToString={(item) => (item ? item.name : '')}
                                            initialSelectedItem={
                                                selectedItemCombo.idProject ? selectedItemCombo.idProject : {}
                                            }
                                            items={appProject}
                                            disabled={
                                                appProject == null || this.state.isDisabled || appProject.length == 0
                                            }
                                            invalid={validations.idProject != null}
                                        />
                                        {validations.idProject}
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="bx--row row-content">
                                <div className="bx--col-lg-12 bx--col-md-12">
                                    <FormGroup legendText="Activity*">
                                        <ComboBox
                                            key={"Activity" + selectedItemCombo.idWorksite + this.state.incidentModel.occurrenceDate}
                                            id="idActivity"
                                            placeholder="Select"
                                            name="idActivity"
                                            alt="incidentModel"
                                            onChange={this.handleChangeCombo}
                                            itemToString={(item) => (item ? item.name : '')}
                                            // initialSelectedItem={
                                            //   selectedItemCombo.idActivity ? selectedItemCombo.idActivity : {}
                                            // }
                                            //RITM0497904
                                            selectedItem={selectedItemCombo.idActivity ? selectedItemCombo.idActivity : {}}
                                            items={appActivity}
                                            disabled={
                                                appActivity == null || this.state.isDisabled || appActivity.length == 0
                                            }
                                            invalid={validations.idActivity != null}
                                        />
                                        {validations.idActivity}
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="bx--row row-content">
                                <div className="bx--col-lg-12 bx--col-md-12">
                                    <FormGroup legendText="">
                                        <StructuredListWrapper className="description-table">
                                            <StructuredListHead>
                                                <StructuredListRow head>
                                                    {/* RITM0945977 */}
                                                    {/* <StructuredListCell head>Division</StructuredListCell> */}
                                                    <StructuredListCell head>Business Line</StructuredListCell>
                                                    <StructuredListCell head>Operating Company</StructuredListCell>
                                                    <StructuredListCell head>Country</StructuredListCell>
                                                    <StructuredListCell head>Client</StructuredListCell>
                                                </StructuredListRow>
                                            </StructuredListHead>
                                            <StructuredListBody>
                                                <StructuredListRow>
                                                    <StructuredListCell>
                                                        {this.state.incidentModel.division}
                                                    </StructuredListCell>
                                                    <StructuredListCell>
                                                        {this.state.incidentModel.company}
                                                    </StructuredListCell>
                                                    <StructuredListCell>
                                                        {this.state.incidentModel.country}
                                                    </StructuredListCell>
                                                    <StructuredListCell>
                                                        {this.state.incidentModel.customer}
                                                    </StructuredListCell>
                                                </StructuredListRow>
                                            </StructuredListBody>
                                        </StructuredListWrapper>
                                    </FormGroup>
                                </div>
                            </div>

                            {/* RITM1405215 */}
                            <div className="title-pagination-description">
                                <h3 className="title--medium">Details</h3>
                            </div>
                            <div className="bx--row">
                                <div className="bx--col-lg-6 bx--col-md-4">
                                    <FormGroup legendText="Title* (It is forbidden to mention any Name and/or Surname. If necessary, use only the IP (Injured Person) wording and generic definition (such as witness, IP))">
                                        <TextInput
                                            id="title"
                                            name="title"
                                            alt="incidentModel"
                                            placeholder="Input title"
                                            value={this.state.incidentModel.title || ''}
                                            onChange={this.handleChangeTitle}
                                            type="text"
                                            hideLabel={true}
                                            labelText=""
                                            disabled={this.state.isDisabled}
                                            invalid={validations.title != null}
                                        />
                                        {validations.title}
                                    </FormGroup>
                                </div>
                                <div className="bx--col-lg-6 bx--col-md-4">
                                    <FormGroup legendText="Work Related*">
                                        <ComboBox
                                            id="workRelated"
                                            placeholder="Select"
                                            name="workRelated"
                                            alt="incidentModel"
                                            onChange={this.handleChangeCombo}
                                            itemToString={(item) => (item ? item.text : '')}
                                            initialSelectedItem={selectedItemCombo.workRelated}
                                            items={this.props.appWorkRelated}
                                            invalid={validations.workRelated != null}
                                            disabled={this.state.isDisabled}
                                        />
                                        {validations.workRelated}
                                    </FormGroup>
                                </div>
                            </div>
                            {showIsWorkRelatedCommunting && (
                                <div className="bx--row ">
                                    <div className="bx--col-lg-6 bx--col-md-4">
                                        <FormGroup legendText="Place*">
                                            <ComboBox
                                                id="place"
                                                placeholder="Select"
                                                name="place"
                                                alt="incidentModel"
                                                onChange={this.handleChangeCombo}
                                                itemToString={(item) => (item ? item.text : '')}
                                                initialSelectedItem={selectedItemCombo.place}
                                                items={this.props.appPlace}
                                                invalid={validations.place != null}
                                                disabled={this.state.isDisabled}
                                            />
                                            {validations.place}
                                        </FormGroup>
                                    </div>
                                    <div className="bx--col-lg-6 bx--col-md-4">
                                        <FormGroup legendText="Company Vehicle Provided*">
                                            <RadioButtonGroup
                                                labelPosition="right"
                                                legend=""
                                                name="companyVehicleProvided"
                                                onChange={this.handleChangeRadio}
                                                orientation="horizontal"
                                                valueSelected={
                                                    this.state.incidentModel.companyVehicleProvided != null
                                                        ? this.state.incidentModel.companyVehicleProvided.toString()
                                                        : ''
                                                }
                                            >
                                                <RadioButton
                                                    id="cvpYes"
                                                    value="true"
                                                    labelText="Yes"
                                                    alt="incidentModel"
                                                    disabled={this.state.isDisabled}
                                                />
                                                <RadioButton
                                                    id="cvpNo"
                                                    value="false"
                                                    labelText="No"
                                                    alt="incidentModel"
                                                    disabled={this.state.isDisabled}
                                                />
                                            </RadioButtonGroup>
                                            {validations.companyVehicleProvided}
                                        </FormGroup>
                                    </div>
                                </div>
                            )}

                            <div className="bx--row row-content ">
                                <div className="bx--col-lg-12 bx--col-md-10">
                                    <FormGroup legendText="Brief Description (It is forbidden to mention any Name and/or Surname. If necessary, use only the IP (Injured Person) wording and generic definition (such as witness, IP))">
                                        <TextArea
                                            maxLength={5000}
                                            id="briefDescription"
                                            placeholder="Input brief description"
                                            value={this.state.incidentModel.briefDescription || ''}
                                            onChange={(el) =>
                                                this.updateState('briefDescription', el.target.value, 'incidentModel')
                                            }
                                            hideLabel={true}
                                            labelText=""
                                            light
                                            rows={4}
                                            cols={100}
                                            disabled={this.state.isDisabled}
                                        />
                                    </FormGroup>
                                </div>
                                <div className="bx--col-lg-12 bx--col-md-10">
                                    <FormGroup legendText="Immediate Actions Taken (It is forbidden to mention any Name and/or Surname. If necessary, use only the IP (Injured Person) wording and generic definition (such as witness, IP))">
                                        <TextArea
                                            maxLength={5000}
                                            id="immediateActionsTaken"
                                            placeholder="Input immediate actions taken"
                                            value={this.state.incidentModel.immediateActionsTaken || ''}
                                            onChange={(el) =>
                                                this.updateState('immediateActionsTaken', el.target.value, 'incidentModel')
                                            }
                                            hideLabel={true}
                                            labelText=""
                                            light
                                            rows={4}
                                            cols={100}
                                            disabled={this.state.isDisabled}
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                            {/* End */}
                        </Section>
                        <Section id="generaldata">
                            <div>
                                <h3 className="title--medium--expressive section">1.2 Incident description</h3>
                            </div>
                            <div className="bx--row section">
                                <div className="bx--col-lg-6 bx--col-md-4">
                                    <FormGroup legendText="Type">
                                        <h4>{typeIncident.text}</h4>
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="bx--row section">
                                <div className="bx--col-max">
                                    <div className="bx--row">
                                        <div className="bx--col-lg-6 bx--col-md-4">
                                            <legend className="bx--label">Potential OutCome*</legend>
                                            <legend className="bx--label">It can be selected one or more </legend>
                                        </div>
                                        <div className="bx--col-lg-6 bx--col-md-4">
                                            <legend className="bx--label">Real OutCome?*</legend>
                                            <legend className="bx--label"> </legend>
                                        </div>
                                    </div>

                                    <div className="bx--row">
                                        <div className="bx--col-lg-6 bx--col-md-4">
                                            <Checkbox
                                                id="outcomeHarm"
                                                alt="incidentModel"
                                                labelText="Harm To People"
                                                checked={this.state.incidentModel.outcomeHarm || false}
                                                onChange={this.handleChangeOutcome}
                                                disabled={this.state.isDisabled}
                                            />
                                        </div>
                                        <div className="bx--col-lg-6 bx--col-md-4">
                                            <RadioButtonGroup
                                                labelPosition="right"
                                                legend=""
                                                name="realOutcomeHarm"
                                                onChange={this.handleChangeRadio}
                                                orientation="horizontal"
                                                valueSelected={
                                                    this.state.incidentModel.realOutcomeHarm != null
                                                        ? this.state.incidentModel.realOutcomeHarm.toString()
                                                        : ''
                                                }
                                            >
                                                <RadioButton
                                                    id="rohYes"
                                                    value="true"
                                                    labelText="Yes"
                                                    alt="incidentModel"
                                                    disabled={
                                                        this.state.incidentModel.outcomeHarm != true || this.state.isDisabled
                                                    }
                                                />
                                                <RadioButton
                                                    id="rohNo"
                                                    value="false"
                                                    labelText="No"
                                                    alt="incidentModel"
                                                    disabled={
                                                        this.state.incidentModel.outcomeHarm != true || this.state.isDisabled
                                                    }
                                                />
                                            </RadioButtonGroup>
                                        </div>
                                    </div>

                                    <div className="bx--row">
                                        <div className="bx--col-lg-6 bx--col-md-4">
                                            <Checkbox
                                                id="outcomeAsset"
                                                alt="incidentModel"
                                                labelText="Property/Asset"
                                                checked={this.state.incidentModel.outcomeAsset || false}
                                                onChange={this.handleChangeOutcome}
                                                disabled={this.state.isDisabled}
                                            />
                                        </div>
                                        <div className="bx--col-lg-6 bx--col-md-4">
                                            <RadioButtonGroup
                                                labelPosition="right"
                                                legend=""
                                                name="realOutcomeAsset"
                                                onChange={this.handleChangeRadio}
                                                orientation="horizontal"
                                                valueSelected={
                                                    this.state.incidentModel.realOutcomeAsset != null
                                                        ? this.state.incidentModel.realOutcomeAsset.toString()
                                                        : ''
                                                }
                                            >
                                                <RadioButton
                                                    key="roaYes"
                                                    id="roaYes"
                                                    name="roaYes"
                                                    value="true"
                                                    labelText="Yes"
                                                    alt="incidentModel"
                                                    disabled={
                                                        this.state.incidentModel.outcomeAsset != true || this.state.isDisabled
                                                    }
                                                />
                                                <RadioButton
                                                    key="roaNo"
                                                    id="roaNo"
                                                    value="false"
                                                    labelText="No"
                                                    alt="incidentModel"
                                                    disabled={
                                                        this.state.incidentModel.outcomeAsset != true || this.state.isDisabled
                                                    }
                                                />
                                            </RadioButtonGroup>
                                        </div>
                                    </div>

                                    <div className="bx--row">
                                        <div className="bx--col-lg-6 bx--col-md-4">
                                            <Checkbox
                                                id="outcomeEnvironmental"
                                                alt="incidentModel"
                                                labelText="Environmental"
                                                checked={this.state.incidentModel.outcomeEnvironmental || false}
                                                onChange={this.handleChangeOutcome}
                                                disabled={this.state.isDisabled}
                                            />
                                        </div>
                                        <div className="bx--col-lg-6 bx--col-md-4">
                                            <RadioButtonGroup
                                                labelPosition="right"
                                                legend=""
                                                name="realOutcomeEnvironmental"
                                                onChange={this.handleChangeRadio}
                                                orientation="horizontal"
                                                valueSelected={
                                                    this.state.incidentModel.realOutcomeEnvironmental != null
                                                        ? this.state.incidentModel.realOutcomeEnvironmental.toString()
                                                        : ''
                                                }
                                            >
                                                <RadioButton
                                                    id="roeYes"
                                                    value="true"
                                                    labelText="Yes"
                                                    alt="incidentModel"
                                                    disabled={
                                                        this.state.incidentModel.outcomeEnvironmental != true ||
                                                        this.state.isDisabled
                                                    }
                                                />
                                                <RadioButton
                                                    id="roeNo"
                                                    value="false"
                                                    labelText="No"
                                                    alt="incidentModel"
                                                    disabled={
                                                        this.state.incidentModel.outcomeEnvironmental != true ||
                                                        this.state.isDisabled
                                                    }
                                                />
                                            </RadioButtonGroup>
                                        </div>
                                    </div>

                                    <div className="error-validation-message">
                                        {validations.outcome}
                                        {this.state.incidentModel.outcomeAsset ? validations.realOutcomeAsset : ''}
                                        {this.state.incidentModel.outcomeEnvironmental
                                            ? validations.realOutcomeEnvironmental
                                            : ''}
                                        {this.state.incidentModel.outcomeHarm ? validations.realOutcomeHarm : ''}
                                    </div>
                                </div>
                            </div>

                            {typeIncident.isAccident && (
                                <>
                                    <div className="bx--row ">
                                        <div className="bx--col-lg-6 bx--col-md-4">
                                            <FormGroup legendText={this.state.incidentModel.realOutcomeHarm == true || this.state.incidentModel.realOutcomeAsset == true || this.state.incidentModel.realOutcomeEnvironmental == true ? "Country LCU Notified*" : "Country LCU Notified"}>  {/* RITM1063909 */} {/* RITM1195257 modified Emergency Class as Country LCU  */}
                                                {/* <RadioButtonGroup
                                                    labelPosition="right"
                                                    legend=""
                                                    name="emergencyClass"
                                                    onChange={this.handleChangeRadio}
                                                    orientation="vertical"
                                                    valueSelected={this.state.incidentModel.emergencyClass}
                                                >
                                                    <RadioButton
                                                        id="ecl1"
                                                        value="Level1"
                                                        labelText="Level 1: managed locally with the personnel and equipment available at worksite "
                                                        alt="incidentModel"
                                                        disabled={this.state.isDisabled}
                                                    />
                                                    <RadioButton
                                                        id="ecl2"
                                                        value="Level2"
                                                        labelText="Level 2: required the intervention of local facilities and resources outsite the organization"
                                                        alt="incidentModel"
                                                        disabled={this.state.isDisabled}
                                                    />
                                                    <RadioButton
                                                        id="ecl3"
                                                        value="Level3"
                                                        labelText="Level 3: it is necessary to request the central intervention of the public, but no locals, authorities / administrations"
                                                        alt="incidentModel"
                                                        disabled={this.state.isDisabled}
                                                    />
                                                    <RadioButton
                                                        id="ecCrisis"
                                                        value="Crisis"
                                                        labelText="Crisis"
                                                        alt="incidentModel"
                                                        disabled={this.state.isDisabled}
                                                    />
                                                </RadioButtonGroup> */}
                                                {/* RITM1195257 added change start */}
                                                <RadioButtonGroup
                                                    labelPosition="right"
                                                    legend=""
                                                    name="countryLCU"
                                                    onChange={this.handleChangeRadio}
                                                    orientation="horizontal"
                                                    valueSelected={this.state.incidentModel.countryLCU}
                                                >
                                                    <RadioButton
                                                        id="Yes"
                                                        value="Yes"
                                                        labelText="Yes"
                                                        alt="incidentModel"
                                                        disabled={this.state.isDisabled}
                                                    />
                                                    <RadioButton
                                                        id="No"
                                                        value="No"
                                                        labelText="No"
                                                        alt="incidentModel"
                                                        disabled={this.state.isDisabled}
                                                    />
                                                    <RadioButton
                                                        id="NA"
                                                        value="NA"
                                                        labelText="Not Applicable"
                                                        alt="incidentModel"
                                                        disabled={true}
                                                        className='hideincidentcountrylcuna' //RITM1195257
                                                    />
                                                </RadioButtonGroup>
                                                {/* RITM1195257 added change End */}
                                            </FormGroup>
                                        </div>
                                        <div className="bx--col-lg-6 bx--col-md-4">
                                            <FormGroup legendText="Public Authorities and Entities Involved">
                                                {/* RITM1405215 */}
                                                {this.props.appPublicAuthoritiesAndEntitiesInvolved == null ? (
                                                    <DropdownSkeleton />
                                                    ) : (
                                                    // aggiunto
                                                    <MultiSelect.Filterable
                                                        id="guidPubAutEntInv"
                                                        placeholder={
                                                            this.state.incidentModel.publicAuthoritiesAndEntitiesInvolved == ''
                                                            ? "Choose one or more items"
                                                            :  selectedItemCombo.selectedPubAutEntInv?.map((elem) => elem.name).join(', ')
                                                        }
                                                        itemToString={(item) => (item ? item.name : "")}
                                                        items={this.props.appPublicAuthoritiesAndEntitiesInvolved}
                                                        onChange={this.handleChangePubAutEntInv}
                                                        type="default"
                                                        initialSelectedItems={selectedItemCombo.selectedPubAutEntInv}
                                                        disabled={this.state.isDisabled}
                                                        sortItems={(items) => items}
                                                    />
                                                )}
                                                {/* End */}
                                                {showSpecifyOther && (
                                                    <TextInput
                                                        id="specifyOther"
                                                        name="specifyOther"
                                                        alt="incidentModel"
                                                        placeholder="Specify other..."
                                                        value={this.state.incidentModel.specifyOther || ''}
                                                        onChange={this.handleChangeModel}
                                                        type="text"
                                                        labelText="Specify other*"
                                                        disabled={this.state.isDisabled}
                                                        invalid={validations.specifyOther != null}
                                                    />
                                                )}
                                                {validations.specifyOther}
                                            </FormGroup>
                                        </div>
                                    </div>
                                    {/* RITM1063909 */}
                                    <div className="error-validation-message">
                                         {this.state.incidentModel.realOutcomeAsset == true ||
                                         this.state.incidentModel.realOutcomeEnvironmental == true ||
                                        
                                         this.state.incidentModel.realOutcomeHarm == true ? validations.countryLCU : ''}   {/*  RITM1195257 added countryLCU    */}
                                    </div>
                                    {/* End */}
                                    <div className="bx--row row-content">
                                        <div className="bx--col-lg-12 bx--col-md-12">
                                            <FormGroup legendText="Transport Accident">
                                                <ComboBox
                                                    id="transportAccident"
                                                    placeholder="Select"
                                                    name="transportAccident"
                                                    alt="incidentModel"
                                                    onChange={this.handleChangeCombo}
                                                    itemToString={(item) => (item ? item.text : '')}
                                                    initialSelectedItem={selectedItemCombo.transportAccident}
                                                    items={this.props.appTransportAccident}
                                                    disabled={this.state.isDisabled}
                                                />
                                            </FormGroup>
                                            {showTransportAccidentEquipped && (
                                                <FormGroup legendText="Is the vehicle equipped with IVMS and Roll Bar*">
                                                    <RadioButtonGroup
                                                        labelPosition="right"
                                                        legend=""
                                                        name="transportAccidentEquipped"
                                                        onChange={this.handleChangeRadio}
                                                        orientation="horizontal"
                                                        valueSelected={
                                                            this.state.incidentModel.transportAccidentEquipped != null
                                                                ? this.state.incidentModel.transportAccidentEquipped.toString()
                                                                : ''
                                                        }
                                                    >
                                                        <RadioButton
                                                            id="taeYes"
                                                            value="true"
                                                            labelText="Yes"
                                                            alt="incidentModel"
                                                            disabled={this.state.isDisabled}
                                                        />
                                                        <RadioButton
                                                            id="taeNo"
                                                            value="false"
                                                            labelText="No"
                                                            alt="incidentModel"
                                                            disabled={this.state.isDisabled}
                                                        />
                                                    </RadioButtonGroup>
                                                </FormGroup>
                                            )}
                                        </div>
                                    </div>
                                </>
                            )}
                            <div className="bx--row">
                                <div className="bx--col-lg-6 bx--col-md-6">
                                    <FormGroup legendText="To be consolidated under*">
                                        <ComboBox
                                            key={'infoOriginator_' + selectedItemCombo.infoOriginator}
                                            id="infoOriginator"
                                            placeholder="Select"
                                            name="infoOriginator"
                                            alt="incidentModel"
                                            onChange={this.handleChangeCombo}
                                            itemToString={(item) => (item ? item.name : '')}
                                            initialSelectedItem={selectedItemCombo.infoOriginator}
                                            items={appInfoOriginator.filter( //RITM1197573
                                                (item) => item.name !== 'SAP')} // Rimuovi l'opzione "SAP" dalla lista
                                            // items={this.props.appInfoOriginator}
                                            disabled={this.state.isDisabled}
                                            invalid={validations.infoOriginator != null}
                                        />
                                        {validations.infoOriginator}
                                    </FormGroup>
                                </div>
                                <div className="bx--col-lg-6 bx--col-md-6">
                                    <FormGroup
                                        legendText={
                                            'SubContractor' +
                                            (selectedItemCombo.infoOriginator?.name === 'Saipem' ? '' : '*')
                                        }
                                    >
                                        <ComboBox
                                            key={'subContractor_' + selectedItemCombo.infoOriginator?.name}
                                            id="subContractor"
                                            placeholder="Select"
                                            name="idSubContractor"
                                            alt="incidentModel"
                                            onChange={this.handleChangeCombo}
                                            itemToString={(item) => (item ? item.name : '')}
                                            initialSelectedItem={selectedItemCombo.subContractor}
                                            items={subContractorsByInfo}
                                            shouldFilterItem={({ item, inputValue }) =>
                                                item.name.toLowerCase().includes(inputValue.toLowerCase())
                                            }
                                            disabled={
                                                this.state.isDisabled ||
                                                selectedItemCombo.infoOriginator?.name === 'Saipem' ||
                                                selectedItemCombo.infoOriginator == null
                                            }
                                            invalid={validations.subContractor != null}
                                        />
                                        {validations.subContractor}
                                    </FormGroup>
                                </div>
                            </div>

                            {/* //RITM0615454_DEV615_MatriciOutcomes */}
                            <div className=" bx--row">
                                <div className="bx--col-lg-12 bx--tab-container bx--tab--conteiner-incident">
                                    <Tabs
                                        selected={this.state.outcomeTab}
                                        onSelectionChange={(index) => this.setState({ outcomeTab: index })}
                                        tabContentClassName="tab-content"
                                    >
                                        {Object.keys(INCIDENT_OUTCOME_ENUM).map(outcomeName => {
                                            const currentOutcome = INCIDENT_OUTCOME_ENUM[outcomeName]
                                            return (
                                                <Tab key={"tab_" + currentOutcome.idOutcome} disabled={!this.state.incidentModel[outcomeName]} label={currentOutcome.title} tabIndex={currentOutcome.idOutcome} />                                            )
                                        })}
                                    </Tabs>
                                    {/* RITM1147493 */}
                                    {/* RITM1405215 */}
                                    {(selectedOutcome?.idOutcome !== 1 ? (
                                        <IncidentHighConsequence 
                                                selectedOutcomeModel={this.state.incidentModel?.incidentOutcomes?.find(out => out.idOutcome === selectedOutcome?.idOutcome) ?? { idOutcome: selectedOutcome?.idOutcome, idIncident: this.state.incidentModel?.id }}
                                                handleHighConsequenceLevel = {this.handleHighConsequenceLevel}
                                                handleIncidentOutcomeBarrier ={this.handleIncidentOutcomeBarrier}
                                                isDisabled={(this.state.isDisabled ?? false) || !this.state.incidentModel[selectedOutcome?.propertyName]}
                                                outcomeModel={this.state.incidentModel?.incidentOutcomes ?? []}
                                                incidentOutcomesEnums={INCIDENT_OUTCOME_ENUM}
                                                realOutcomeHarm={this.state.incidentModel.realOutcomeHarm} //RITM1216061
                                                realOutcomeEnvironmental={this.state.incidentModel.realOutcomeEnvironmental} //RITM1216061
                                                validations={validations ?? {}} 
                                                appHighConsequenceLevels={this.props.appHighConsequenceLevels ?? []} //RITM1216061                                 
                                                />
                                        ) : (
                                            <>
                                                <div className="bx--row">
                                                    <div className="bx--col-md-4 bx--col-lg-6">
                                                        <FormGroup legendText={"Real Consequence*"}>
                                                            <ComboBox
                                                                id="idRealConsequenceLevel"
                                                                placeholder="Select"
                                                                name="idRealConsequenceLevel"
                                                                alt="incidentModel"
                                                                onChange={this.handleRealPotentialConsequenceLevel}
                                                                itemToString={item => (item ? item.name : '')}
                                                                selectedItem={selectedItemCombo.realConsequence}
                                                                items={this.props.appRealPotentialConsequenceLevels}                                                                                                                 
                                                                invalid={validations.realConsequence != null}
                                                                disabled={this.state.isDisabled}
                                                            />
                                                        {validations.realConsequence}
                                                        </FormGroup>
                                                    </div>
                                                    <div className="bx--col-md-4 bx--col-lg-6">
                                                        <FormGroup legendText={"Potential Consequence*"}>
                                                            <ComboBox
                                                                id="idPotentialConsequenceLevel"
                                                                placeholder="Select"
                                                                name="idPotentialConsequenceLevel"
                                                                alt="incidentModel"
                                                                onChange={this.handleRealPotentialConsequenceLevel}
                                                                itemToString={item => (item ? item.name : '')}
                                                                selectedItem={selectedItemCombo.potentialConsequence}
                                                                items={this.props.appRealPotentialConsequenceLevels}                                                                                                                 
                                                                invalid={validations.potentialConsequence != null}
                                                                disabled={this.state.isDisabled}
                                                            />
                                                        {validations.potentialConsequence}
                                                        </FormGroup>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    )}
                                    {/* End */}
                                </div>
                            </div>
                            {/* FINE //RITM0615454_DEV615_MatriciOutcomes */}

                            
                            {/*  //RITM0615454_DEV615_MatriciOutcomes */}

                            <div className="bx--row">
                                <div className="bx--col-lg-12">
                                    <h3 className="title--medium">Life Saving Rules Violations</h3>
                                </div>
                                <div>{validations.lifeSavingRules}</div>
                            </div>
                            <div className="bx--row">
                                {this.props.appLifeSavingRuleCategory.map((item) => (
                                    // <FormGroup
                                    //   // legendText={item.name}
                                    //   key={item.id}
                                    //   className="bx--col--md-12 bx--col-lg-12 "
                                    // >
                                    <div className="bx--row">
                                        {this.getLifeSavingRuleByCategory(this.props.appLifeSavingRule, item.id).map(
                                            (rule) => (
                                                <div key={'LifeSavingRule' + rule.id} className="bx--col-lg-3 ">
                                                    <Checkbox
                                                        id={rule.id}
                                                        key={rule.id}
                                                        labelText={rule.name}
                                                        checked={
                                                            (this.state.incidentModel.lifeSavingRules || []).find(
                                                                (el) => el.idLifeSavingRule == rule.id
                                                            ) != null
                                                        }
                                                        onChange={this.handleChangeLifeSavingRules}
                                                        className=""
                                                        // RITM0615447
                                                        disabled={this.isLifeSavingRulesDisabled(rule.id)}
                                                    />
                                                </div>
                                            )
                                        )}
                                    </div>
                                    //  </FormGroup>   
                                ))}
                                {/* RITM0615447 */}
                                <div className="bx--col-lg-3" style={{ marginTop: "12px" }}>
                                    <Checkbox
                                        id={NoViolationLSR?.id}
                                        key={NoViolationLSR?.id}
                                        labelText={NoViolationLSR?.name}
                                        checked={
                                            (this.state.incidentModel.lifeSavingRules || []).find(
                                                (el) => el.idLifeSavingRule == NoViolationLSR?.id
                                            ) != null
                                        }
                                        onChange={this.handleChangeLifeSavingRules}
                                        className=""
                                        disabled={this.isLifeSavingRulesDisabled(NoViolationLSR?.id)}
                                    />
                                </div>
                            </div>
                            {this.props.toSubmit && (this.state.incidentModel.lifeSavingRules == null || this.state.incidentModel.lifeSavingRules?.length <= 0) ? 
                                <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                                    <div className="error-validation-message srv-validation-message">The life saving rules violation field is required.</div>
                                </div> 
                                : <></>
                            }
                            
                            {/* FINE RITM0615447 */}
                            <div className="bx--row row-content">
                                <div className="bx--col-lg-12">
                                    <FormGroup legendText="Additional info about the LSR violation (It is forbidden to mention any Name and/or Surname. If necessary, use only the IP (Injured Person) wording and generic definition (such as witness, IP))">
                                        <TextArea
                                            maxLength={5000}
                                            id="lsrNote"
                                            value={this.state.incidentModel.lsrNote || ''}
                                            onChange={(el) =>
                                                this.updateState('lsrNote', el.target.value, 'incidentModel')
                                            }
                                            hideLabel={true}
                                            labelText=""
                                            light
                                            rows={4}
                                            cols={100}
                                            disabled={this.state.isDisabled}
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                            {/* RITM1143712 */}
                            <div className="bx--row ">
                                <div className="bx--col-lg-6">
                                    <FormGroup legendText="Incident Typology* (select only single typology which is most relevant)">
                                        {appIncidentTypology == null ? (
                                        <DropdownSkeleton />
                                        ) : (
                                        // aggiunto
                                        <MultiSelect.Filterable
                                            id="guidIncidentTypology"
                                            invalid={validations.incidentTypology != null}
                                            invalidText={validations.incidentTypology}
                                            placeholder={
                                                this.state.incidentModel.incidentTypologies?.length < 1 || this.state.incidentModel.incidentTypologies == null
                                                  ? "Choose one or more items"
                                                  :  selectedItemCombo.selectedTypologies?.map((elem) => elem.name).join(', ')
                                              }
                                            itemToString={(item) => (item ? item.name : "")}
                                            items={appIncidentTypology}
                                            onChange={this.onChange}
                                            type="default"
                                            initialSelectedItems={selectedItemCombo.selectedTypologies}
                                            disabled={this.state.isDisabled}
                                            sortItems={(items) => items}
                                        />
                                        )}
                                    </FormGroup>
                                </div>
                                {showOtherTypology && (
                                <div className="bx--col-lg-6">
                                    <FormGroup legendText="Specify other*">
                                        <TextInput
                                            id="specifyOtherTypology"
                                            name="specifyOtherTypology"
                                            alt="incidentModel"
                                            placeholder="Specify other..."
                                            value={this.state.incidentModel.incidentTypologies?.find(el => el?.typology?.name?.toLowerCase() === 'others')?.specifyOther || ''}
                                            onChange={this.handleSpecifyOthersTypology}
                                            type="text"
                                            hideLabel="true"
                                            disabled={this.state.isDisabled}
                                            invalid={validations.incidentTypologySpecifyOther != null}
                                        />
                                        {validations.incidentTypologySpecifyOther}
                                   </FormGroup>
                                </div>
                                )}
                            </div>
                            {/* End */}
                            <div className="bx--row ">
                                <div className="bx--col-lg-12">
                                    <h3 className="title--medium">Attachments</h3>
                                    <h5>(It is prohibited to add in the report/notification any sensitive picture (i.e. wound, stitches, broken part, etc..) or any sensitive information related to the injured person. It is also forbidden to upload photos on which is possible to recognize specific people)</h5>
                                </div>
                            </div>
                            <IncidentAttachment
                                attachments={this.state.incidentModel.attachmentNotifications}
                                addNewAttachment={this.addNewAttachment}
                                removeAttachment={this.removeAttachment}
                                isDisabled={this.state.isDisabled}
                                idIncident={this.state.incidentModel.id}
                                flagNotificationTab={true}
                            />
                            <div className="error-validation-message">{validations.attachment}</div>
                        </Section>
                        <Section id="incidentdescription">
                            <div>
                                <h3 className="title--medium--expressive section--title">1.3 General Data </h3>
                            </div>
                            <div className="bx--row title-pagination-description">
                                <h4 className="title--medium">Notification Finalisation</h4>
                            </div>
                            <div className="bx--row">
                                {this.state.incidentModel && this.state.incidentModel.notificationDate &&
                                    !this.state.incidentModel.notificationDate.startsWith('0001-01-01') && (
                                    <div className="bx--col-lg-6 bx--col-md-8">
                                        <FormGroup legendText="Notification Date">
                                            <TextInput
                                                id="notificationDate"
                                                name="notificationDate"
                                                alt="incidentModel"
                                                placeholder=""
                                                value={switchDateFormat(
                                                    this.state.incidentModel.notificationDate,
                                                    'datetime'
                                                )}
                                                readOnly={true}
                                                type="text"
                                                hideLabel={true}
                                                labelText=""
                                                disabled={this.state.isDisabled}
                                            />
                                        </FormGroup>
                                    </div>
                                )}
                            </div>
                            <div className="bx--row ">
                                <div className="bx--col-lg-6 bx--col-md-4">
                                    <FormGroup legendText="Mail To* (Personal Email and Addresses are not allowed)">
                                        <EmailChips
                                            value={this.state.incidentModel.mailTo || ''}
                                            type="text"
                                            onChange={(value) => this.updateState('mailTo', value, 'incidentModel')}
                                            invalid={validations.mailTo != null}
                                            disabled={this.state.isDisabled}
                                            title="&#9888; Do Not use Personal Accounts"
                                            masked={this.state.incidentModel.maskedValue} //RITM0946001 - Anonimizzazione Modulo Incident
                                        //placeholder="Input mail To"
                                        />

                                        {/* <TextInput
                                        id="mailTo"
                                        name="mailTo"
                                        alt="incidentModel"
                                        placeholder="Input mailTo"
                                        value={this.state.incidentModel.mailTo || ''}
                                        onChange={this.handleChangeModel}
                                        type="text"
                                        hideLabel={true}
                                        labelText=""
                                        invalid={validations.mailTo != null}
                                        disabled={this.state.isDisabled}
                                    /> */}
                                        {validations.mailTo}
                                    </FormGroup>
                                </div>
                                <div className="bx--col-lg-6 bx--col-md-4">
                                    <FormGroup legendText="Mail CC (Personal Email Addresses are not allowed)">
                                        <EmailChips
                                            value={this.state.incidentModel.mailCc || ''}
                                            type="text"
                                            onChange={(value) => this.updateState('mailCc', value, 'incidentModel')}
                                            disabled={this.state.isDisabled}
                                            title="&#9888; Do Not use Personal Accounts"
                                            masked={this.state.incidentModel.maskedValue} //RITM0946001 - Anonimizzazione Modulo Incident
                                        //placeholder="Input mail Cc"
                                        />
                                        {/* <TextInput
                                        id="mailCc"
                                        name="mailCc"
                                        alt="incidentModel"
                                        placeholder="Input mailCc"
                                        value={this.state.incidentModel.mailCc || ''}
                                        onChange={this.handleChangeModel}
                                        type="text"
                                        hideLabel={true}
                                        labelText=""
                                        invalid={validations.mailCc != null}
                                        disabled={this.state.isDisabled}
                                    /> */}
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="bx--row row-content">
                                <div className="bx--col-lg-12">
                                    <FormGroup legendText="Message* (It is forbidden to mention any Name and/or Surname. If necessary, use only the IP (Injured Person) wording and generic definition (such as witness, IP))">
                                        <TextArea
                                            maxLength={5000}
                                            id="mailBody"
                                            placeholder="Input message"
                                            value={this.state.incidentModel.mailBody || ''}
                                            onChange={(el) =>
                                                this.updateState('mailBody', el.target.value, 'incidentModel')
                                            }
                                            hideLabel={true}
                                            labelText=""
                                            light
                                            rows={4}
                                            cols={100}
                                            disabled={this.state.isDisabled}
                                            invalid={validations.mailBody != null}
                                        />
                                        {validations.mailBody}
                                    </FormGroup>
                                </div>
                            </div>
                        </Section>
                    </div>
                </div>
                <div className="bx--row">
                    <Button disabled className="bx--col bx--btn--max-width" size="default" kind="secondary">
                        Prev Step
          </Button>
                    <Button
                        onClick={() => this.props.cancel()}
                        className="bx--col bx--btn--max-width"
                        size="default"
                        kind="secondary"
                    >
                        Cancel
          </Button>
                    <Button
                        onClick={() => this.saveTabNotification(false)}
                        disabled={this.state.isDisabled}
                        className="bx--col bx--btn--max-width"
                        size="default"
                        kind="primary"
                    >
                        Save
          </Button>
                    <Button
                        onClick={() => this.saveTabNotification(true)}
                        disabled={this.state.isDisabled}
                        className="bx--col bx--btn--max-width"
                        size="default"
                        kind="primary"
                    >
                        Save & Send
          </Button>
                    <Button
                        onClick={() => window.print()}
                        disabled={this.state.isDisabled}
                        className="bx--col bx--btn--max-width"
                        size="default"
                        kind="secondary"
                    >
                        Print
          </Button>
                    <Button
                        onClick={() => this.selectTab(1)}
                        disabled={!this.props.isEdit}
                        className="bx--col bx--btn--max-width"
                        size="default"
                        kind="secondary"
                    >
                        Next Step
          </Button>
                </div>
            </>
        );
    }
}
